// Generated by tools/animation/extract_native_cloth_evidence.py.
// Do not hand-edit; values come from the original Shenmue I executable.

function deepFreeze(value) {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;
  for (const child of Object.values(value)) deepFreeze(child);
  return Object.freeze(value);
}

const DATA = deepFreeze({
  "characterProfiles": {
    "YKB": {
      "profileIndex": 0,
      "bodyCollisionProfileAddress": "0x0c282208",
      "rawControlBytes": [
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "YKC": {
      "profileIndex": 1,
      "bodyCollisionProfileAddress": "0x0c282208",
      "rawControlBytes": [
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "YKE": {
      "profileIndex": 2,
      "bodyCollisionProfileAddress": "0x0c282208",
      "rawControlBytes": [
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "YKV": {
      "profileIndex": 3,
      "bodyCollisionProfileAddress": "0x0c282208",
      "rawControlBytes": [
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "YKG": {
      "profileIndex": 4,
      "bodyCollisionProfileAddress": "0x0c282208",
      "rawControlBytes": [
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "BYR": {
      "profileIndex": 5,
      "bodyCollisionProfileAddress": "0x0c282258",
      "rawControlBytes": [
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "RKN": {
      "profileIndex": 6,
      "bodyCollisionProfileAddress": "0x0c2824f6",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KOT": {
      "profileIndex": 7,
      "bodyCollisionProfileAddress": "0x0c28242e",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "ASO": {
      "profileIndex": 8,
      "bodyCollisionProfileAddress": "0x0c282474",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "FUU": {
      "profileIndex": 9,
      "bodyCollisionProfileAddress": "0x0c283d06",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "CHA": {
      "profileIndex": 10,
      "bodyCollisionProfileAddress": "0x0c2823de",
      "rawControlBytes": [
        5,
        253,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SIN": {
      "profileIndex": 11,
      "bodyCollisionProfileAddress": "0x0c28229e",
      "rawControlBytes": [
        0,
        6,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HOB": {
      "profileIndex": 12,
      "bodyCollisionProfileAddress": "0x0c282334",
      "rawControlBytes": [
        0,
        2,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KOK": {
      "profileIndex": 13,
      "bodyCollisionProfileAddress": "0x0c282514",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        0,
        0,
        0
      ]
    },
    "TAT": {
      "profileIndex": 14,
      "bodyCollisionProfileAddress": "0x0c2826fe",
      "rawControlBytes": [
        4,
        255,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HIR": {
      "profileIndex": 15,
      "bodyCollisionProfileAddress": "0x0c2825aa",
      "rawControlBytes": [
        0,
        2,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "ASD": {
      "profileIndex": 16,
      "bodyCollisionProfileAddress": "0x0c2825dc",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "CHU": {
      "profileIndex": 17,
      "bodyCollisionProfileAddress": "0x0c282636",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "TUB": {
      "profileIndex": 18,
      "bodyCollisionProfileAddress": "0x0c282690",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        0,
        0,
        0
      ]
    },
    "YEG": {
      "profileIndex": 19,
      "bodyCollisionProfileAddress": "0x0c282744",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KYF": {
      "profileIndex": 20,
      "bodyCollisionProfileAddress": "0x0c28279e",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SIA": {
      "profileIndex": 21,
      "bodyCollisionProfileAddress": "0x0c282820",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HGC": {
      "profileIndex": 22,
      "bodyCollisionProfileAddress": "0x0c2828a2",
      "rawControlBytes": [
        2,
        255,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SYU": {
      "profileIndex": 23,
      "bodyCollisionProfileAddress": "0x0c282956",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        0,
        0,
        0
      ]
    },
    "YMO": {
      "profileIndex": 24,
      "bodyCollisionProfileAddress": "0x0c2829d8",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BOB": {
      "profileIndex": 25,
      "bodyCollisionProfileAddress": "0x0c282a1e",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KJM": {
      "profileIndex": 26,
      "bodyCollisionProfileAddress": "0x0c282a46",
      "rawControlBytes": [
        0,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YYI": {
      "profileIndex": 27,
      "bodyCollisionProfileAddress": "0x0c282a78",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KIM": {
      "profileIndex": 28,
      "bodyCollisionProfileAddress": "0x0c282ae6",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "OYC": {
      "profileIndex": 29,
      "bodyCollisionProfileAddress": "0x0c282b2c",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HND": {
      "profileIndex": 30,
      "bodyCollisionProfileAddress": "0x0c282b86",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SHA": {
      "profileIndex": 31,
      "bodyCollisionProfileAddress": "0x0c282bf4",
      "rawControlBytes": [
        0,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SIB": {
      "profileIndex": 32,
      "bodyCollisionProfileAddress": "0x0c282c76",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "RFA": {
      "profileIndex": 33,
      "bodyCollisionProfileAddress": "0x0c282cd0",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "RFC": {
      "profileIndex": 34,
      "bodyCollisionProfileAddress": "0x0c283964",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "X77": {
      "profileIndex": 35,
      "bodyCollisionProfileAddress": "0x0c282d16",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YPA": {
      "profileIndex": 36,
      "bodyCollisionProfileAddress": "0x0c282db6",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "TOF": {
      "profileIndex": 37,
      "bodyCollisionProfileAddress": "0x0c282de8",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YAA": {
      "profileIndex": 38,
      "bodyCollisionProfileAddress": "0x0c282e42",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JME": {
      "profileIndex": 39,
      "bodyCollisionProfileAddress": "0x0c282e9c",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JMD": {
      "profileIndex": 40,
      "bodyCollisionProfileAddress": "0x0c282ee2",
      "rawControlBytes": [
        0,
        4,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YAB": {
      "profileIndex": 41,
      "bodyCollisionProfileAddress": "0x0c282f3c",
      "rawControlBytes": [
        2,
        255,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "ZZE": {
      "profileIndex": 42,
      "bodyCollisionProfileAddress": "0x0c282f96",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HSA": {
      "profileIndex": 43,
      "bodyCollisionProfileAddress": "0x0c282fdc",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HRN": {
      "profileIndex": 44,
      "bodyCollisionProfileAddress": "0x0c28305e",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "OBA": {
      "profileIndex": 45,
      "bodyCollisionProfileAddress": "0x0c2830a4",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "OYB": {
      "profileIndex": 46,
      "bodyCollisionProfileAddress": "0x0c283112",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "FRG": {
      "profileIndex": 47,
      "bodyCollisionProfileAddress": "0x0c283158",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SHE": {
      "profileIndex": 48,
      "bodyCollisionProfileAddress": "0x0c28319e",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "PAL": {
      "profileIndex": 49,
      "bodyCollisionProfileAddress": "0x0c28320c",
      "rawControlBytes": [
        2,
        254,
        3,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "OYA": {
      "profileIndex": 50,
      "bodyCollisionProfileAddress": "0x0c283252",
      "rawControlBytes": [
        0,
        255,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "FRA": {
      "profileIndex": 51,
      "bodyCollisionProfileAddress": "0x0c283298",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPE": {
      "profileIndex": 52,
      "bodyCollisionProfileAddress": "0x0c283306",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KMN": {
      "profileIndex": 53,
      "bodyCollisionProfileAddress": "0x0c283388",
      "rawControlBytes": [
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JMC": {
      "profileIndex": 54,
      "bodyCollisionProfileAddress": "0x0c28340a",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPG": {
      "profileIndex": 55,
      "bodyCollisionProfileAddress": "0x0c283450",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BAU": {
      "profileIndex": 56,
      "bodyCollisionProfileAddress": "0x0c2834be",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BGA": {
      "profileIndex": 57,
      "bodyCollisionProfileAddress": "0x0c283504",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JMG": {
      "profileIndex": 58,
      "bodyCollisionProfileAddress": "0x0c28355e",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "INE": {
      "profileIndex": 59,
      "bodyCollisionProfileAddress": "0x0c2835a4",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPF": {
      "profileIndex": 60,
      "bodyCollisionProfileAddress": "0x0c28363a",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "UBA": {
      "profileIndex": 61,
      "bodyCollisionProfileAddress": "0x0c283680",
      "rawControlBytes": [
        6,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SHX": {
      "profileIndex": 62,
      "bodyCollisionProfileAddress": "0x0c2836c6",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        4,
        0,
        0,
        0
      ]
    },
    "HPD": {
      "profileIndex": 63,
      "bodyCollisionProfileAddress": "0x0c283770",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPI": {
      "profileIndex": 64,
      "bodyCollisionProfileAddress": "0x0c2837f2",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPJ": {
      "profileIndex": 65,
      "bodyCollisionProfileAddress": "0x0c283860",
      "rawControlBytes": [
        2,
        255,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPH": {
      "profileIndex": 66,
      "bodyCollisionProfileAddress": "0x0c2838f6",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "RFD": {
      "profileIndex": 67,
      "bodyCollisionProfileAddress": "0x0c2839aa",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SHY": {
      "profileIndex": 68,
      "bodyCollisionProfileAddress": "0x0c283a04",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        4,
        0,
        0,
        0
      ]
    },
    "KAS": {
      "profileIndex": 69,
      "bodyCollisionProfileAddress": "0x0c283aae",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SFF": {
      "profileIndex": 70,
      "bodyCollisionProfileAddress": "0x0c283b30",
      "rawControlBytes": [
        2,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "FRM": {
      "profileIndex": 71,
      "bodyCollisionProfileAddress": "0x0c283b8a",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        4,
        0,
        0,
        0
      ]
    },
    "JMB": {
      "profileIndex": 72,
      "bodyCollisionProfileAddress": "0x0c283c20",
      "rawControlBytes": [
        2,
        255,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SIX": {
      "profileIndex": 73,
      "bodyCollisionProfileAddress": "0x0c28229e",
      "rawControlBytes": [
        0,
        6,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SND": {
      "profileIndex": 74,
      "bodyCollisionProfileAddress": "0x0c283c66",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KHI": {
      "profileIndex": 75,
      "bodyCollisionProfileAddress": "0x0c283cac",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SIH": {
      "profileIndex": 76,
      "bodyCollisionProfileAddress": "0x0c28229e",
      "rawControlBytes": [
        0,
        6,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HGR": {
      "profileIndex": 77,
      "bodyCollisionProfileAddress": "0x0c28229e",
      "rawControlBytes": [
        0,
        6,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "ACS": {
      "profileIndex": 78,
      "bodyCollisionProfileAddress": "0x0c283d4c",
      "rawControlBytes": [
        2,
        255,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SEU": {
      "profileIndex": 79,
      "bodyCollisionProfileAddress": "0x0c283dba",
      "rawControlBytes": [
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "OGM": {
      "profileIndex": 80,
      "bodyCollisionProfileAddress": "0x0c283e28",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "NZM": {
      "profileIndex": 81,
      "bodyCollisionProfileAddress": "0x0c283eaa",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "MRU": {
      "profileIndex": 82,
      "bodyCollisionProfileAddress": "0x0c283f18",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SSI": {
      "profileIndex": 83,
      "bodyCollisionProfileAddress": "0x0c283f72",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SAK": {
      "profileIndex": 84,
      "bodyCollisionProfileAddress": "0x0c283fcc",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SFS": {
      "profileIndex": 85,
      "bodyCollisionProfileAddress": "0x0c283b30",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YKW": {
      "profileIndex": 86,
      "bodyCollisionProfileAddress": "0x0c28404e",
      "rawControlBytes": [
        6,
        251,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KUU": {
      "profileIndex": 87,
      "bodyCollisionProfileAddress": "0x0c2840bc",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPB": {
      "profileIndex": 88,
      "bodyCollisionProfileAddress": "0x0c284116",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "NAT": {
      "profileIndex": 89,
      "bodyCollisionProfileAddress": "0x0c2841c0",
      "rawControlBytes": [
        7,
        255,
        3,
        1,
        4,
        0,
        0,
        0
      ]
    },
    "MAL": {
      "profileIndex": 90,
      "bodyCollisionProfileAddress": "0x0c284288",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YWT": {
      "profileIndex": 91,
      "bodyCollisionProfileAddress": "0x0c2842e2",
      "rawControlBytes": [
        1,
        0,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BUR": {
      "profileIndex": 92,
      "bodyCollisionProfileAddress": "0x0c284350",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JEA": {
      "profileIndex": 93,
      "bodyCollisionProfileAddress": "0x0c2843be",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "FRB": {
      "profileIndex": 94,
      "bodyCollisionProfileAddress": "0x0c28442c",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        0,
        0,
        0
      ]
    },
    "FUW": {
      "profileIndex": 95,
      "bodyCollisionProfileAddress": "0x0c28449a",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HSB": {
      "profileIndex": 96,
      "bodyCollisionProfileAddress": "0x0c284508",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "GKA": {
      "profileIndex": 97,
      "bodyCollisionProfileAddress": "0x0c28458a",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "GRL": {
      "profileIndex": 98,
      "bodyCollisionProfileAddress": "0x0c284634",
      "rawControlBytes": [
        2,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JMA": {
      "profileIndex": 99,
      "bodyCollisionProfileAddress": "0x0c2846a2",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "MIB": {
      "profileIndex": 100,
      "bodyCollisionProfileAddress": "0x0c2846e8",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "NAN": {
      "profileIndex": 101,
      "bodyCollisionProfileAddress": "0x0c28477e",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HGY": {
      "profileIndex": 102,
      "bodyCollisionProfileAddress": "0x0c282208",
      "rawControlBytes": [
        2,
        254,
        2,
        0,
        0,
        1,
        0,
        0
      ]
    },
    "X61": {
      "profileIndex": 103,
      "bodyCollisionProfileAddress": "0x0c284828",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPC": {
      "profileIndex": 104,
      "bodyCollisionProfileAddress": "0x0c284882",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "ONL": {
      "profileIndex": 105,
      "bodyCollisionProfileAddress": "0x0c2848dc",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BWW": {
      "profileIndex": 106,
      "bodyCollisionProfileAddress": "0x0c284936",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "TKI": {
      "profileIndex": 107,
      "bodyCollisionProfileAddress": "0x0c2849b8",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KYK": {
      "profileIndex": 108,
      "bodyCollisionProfileAddress": "0x0c284a3a",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KYS": {
      "profileIndex": 109,
      "bodyCollisionProfileAddress": "0x0c284abc",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JEN": {
      "profileIndex": 110,
      "bodyCollisionProfileAddress": "0x0c284b16",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YAC": {
      "profileIndex": 111,
      "bodyCollisionProfileAddress": "0x0c282f3c",
      "rawControlBytes": [
        2,
        255,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YAE": {
      "profileIndex": 112,
      "bodyCollisionProfileAddress": "0x0c282f3c",
      "rawControlBytes": [
        2,
        255,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "YNF": {
      "profileIndex": 113,
      "bodyCollisionProfileAddress": "0x0c284b98",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KIS": {
      "profileIndex": 114,
      "bodyCollisionProfileAddress": "0x0c284bde",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BKR": {
      "profileIndex": 115,
      "bodyCollisionProfileAddress": "0x0c284bde",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "RKB": {
      "profileIndex": 116,
      "bodyCollisionProfileAddress": "0x0c284c38",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HOS": {
      "profileIndex": 117,
      "bodyCollisionProfileAddress": "0x0c284c92",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        0,
        0,
        0
      ]
    },
    "SNT": {
      "profileIndex": 118,
      "bodyCollisionProfileAddress": "0x0c284d00",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "SCA": {
      "profileIndex": 119,
      "bodyCollisionProfileAddress": "0x0c284d5a",
      "rawControlBytes": [
        0,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HHN": {
      "profileIndex": 120,
      "bodyCollisionProfileAddress": "0x0c284da0",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        3,
        0,
        0
      ]
    },
    "HHT": {
      "profileIndex": 121,
      "bodyCollisionProfileAddress": "0x0c284da0",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        3,
        0,
        0
      ]
    },
    "HHY": {
      "profileIndex": 122,
      "bodyCollisionProfileAddress": "0x0c284e36",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        3,
        0,
        0
      ]
    },
    "HHM": {
      "profileIndex": 123,
      "bodyCollisionProfileAddress": "0x0c284e36",
      "rawControlBytes": [
        0,
        254,
        3,
        1,
        3,
        3,
        0,
        0
      ]
    },
    "MYT": {
      "profileIndex": 124,
      "bodyCollisionProfileAddress": "0x0c284ecc",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "NKK": {
      "profileIndex": 125,
      "bodyCollisionProfileAddress": "0x0c284f26",
      "rawControlBytes": [
        2,
        255,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "NKS": {
      "profileIndex": 126,
      "bodyCollisionProfileAddress": "0x0c284f26",
      "rawControlBytes": [
        2,
        255,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "CMA": {
      "profileIndex": 127,
      "bodyCollisionProfileAddress": "0x0c284f80",
      "rawControlBytes": [
        0,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KWD": {
      "profileIndex": 128,
      "bodyCollisionProfileAddress": "0x0c284fc6",
      "rawControlBytes": [
        0,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "MME": {
      "profileIndex": 129,
      "bodyCollisionProfileAddress": "0x0c28500c",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "TPR": {
      "profileIndex": 130,
      "bodyCollisionProfileAddress": "0x0c28507a",
      "rawControlBytes": [
        6,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "JMF": {
      "profileIndex": 131,
      "bodyCollisionProfileAddress": "0x0c283c20",
      "rawControlBytes": [
        2,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPX": {
      "profileIndex": 132,
      "bodyCollisionProfileAddress": "0x0c2850c0",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "HPY": {
      "profileIndex": 133,
      "bodyCollisionProfileAddress": "0x0c2850c0",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "TOK": {
      "profileIndex": 134,
      "bodyCollisionProfileAddress": "0x0c285106",
      "rawControlBytes": [
        0,
        254,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KVD": {
      "profileIndex": 135,
      "bodyCollisionProfileAddress": "0x0c285160",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KVK": {
      "profileIndex": 136,
      "bodyCollisionProfileAddress": "0x0c285160",
      "rawControlBytes": [
        0,
        254,
        3,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "KMB": {
      "profileIndex": 137,
      "bodyCollisionProfileAddress": "0x0c2851ba",
      "rawControlBytes": [
        2,
        255,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "BAT": {
      "profileIndex": 138,
      "bodyCollisionProfileAddress": "0x0c285200",
      "rawControlBytes": [
        2,
        254,
        2,
        0,
        0,
        0,
        0,
        0
      ]
    },
    "OYD": {
      "profileIndex": 139,
      "bodyCollisionProfileAddress": "0x0c283252",
      "rawControlBytes": [
        0,
        255,
        1,
        0,
        0,
        0,
        0,
        0
      ]
    }
  },
  "fallbackProfile": {
    "profileIndex": 140,
    "bodyCollisionProfileAddress": "0x0c282334",
    "rawControlBytes": [
      0,
      254,
      1,
      0,
      0,
      0,
      0,
      0
    ]
  },
  "bodyCollisionProfiles": {
    "0x0c281b78": {
      "sourceAddress": "0x0c281b78",
      "sourceSha256": "f466cf20c27dee07bf9b6a09748661f4aeea90361af3b008d8f70057f50aaea0",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.01,
            -0.045
          ],
          "radius": 0.135,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.023,
            0.0,
            -0.045
          ],
          "radius": 0.158,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            0.0,
            -0.055
          ],
          "radius": 0.181,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.015,
            -0.075,
            -0.04
          ],
          "radius": 0.218,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.235,
            -0.075,
            -0.05
          ],
          "radius": 0.224,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.39,
            -0.08,
            -0.025
          ],
          "radius": 0.184,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.025,
            -0.12,
            -0.01
          ],
          "radius": 0.163,
          "controllerType": 34,
          "collisionMaskBit": 4096
        },
        {
          "localPosition": [
            -0.03,
            0.01,
            0.045
          ],
          "radius": 0.135,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.023,
            0.0,
            0.045
          ],
          "radius": 0.158,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            0.0,
            0.055
          ],
          "radius": 0.181,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.015,
            -0.075,
            0.04
          ],
          "radius": 0.218,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.235,
            -0.075,
            0.05
          ],
          "radius": 0.224,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.39,
            -0.08,
            0.025
          ],
          "radius": 0.184,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.025,
            -0.12,
            -0.01
          ],
          "radius": 0.163,
          "controllerType": 27,
          "collisionMaskBit": 32768
        }
      ]
    },
    "0x0c281c0e": {
      "sourceAddress": "0x0c281c0e",
      "sourceSha256": "bde07dc26d6dcdc2dc604058f207ac62cc87705ee11a88b7fe1dcb5ba3ee9f3b",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.01,
            -0.045
          ],
          "radius": 0.135,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.023,
            0.0,
            -0.045
          ],
          "radius": 0.158,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.105,
            0.0,
            -0.055
          ],
          "radius": 0.176,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.095,
            0.0,
            0.0
          ],
          "radius": 0.158,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.21,
            -0.005,
            -0.015
          ],
          "radius": 0.204,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.34,
            -0.02,
            0.005
          ],
          "radius": 0.173,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            -0.065,
            0.0
          ],
          "radius": 0.134,
          "controllerType": 34,
          "collisionMaskBit": 4096
        },
        {
          "localPosition": [
            -0.03,
            0.01,
            0.045
          ],
          "radius": 0.135,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.023,
            0.0,
            0.045
          ],
          "radius": 0.158,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.25,
            0.0,
            0.055
          ],
          "radius": 0.193,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.05,
            -0.015,
            0.045
          ],
          "radius": 0.187,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.09,
            -0.015,
            0.065
          ],
          "radius": 0.189,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.25,
            0.005,
            0.045
          ],
          "radius": 0.167,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.03,
            -0.065,
            0.0
          ],
          "radius": 0.159,
          "controllerType": 27,
          "collisionMaskBit": 32768
        }
      ]
    },
    "0x0c281ca4": {
      "sourceAddress": "0x0c281ca4",
      "sourceSha256": "03b5e71a32e941baa8b131f6e9446e4592654989a69886a3a20313473b331136",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.01,
            -0.06
          ],
          "radius": 0.142,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.033,
            -0.01,
            -0.045
          ],
          "radius": 0.154,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            -0.025,
            -0.055
          ],
          "radius": 0.154,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.095,
            -0.035,
            0.0
          ],
          "radius": 0.142,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.05,
            -0.035,
            -0.015
          ],
          "radius": 0.178,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.21,
            -0.045,
            -0.02
          ],
          "radius": 0.172,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            0.01,
            0.06
          ],
          "radius": 0.142,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.033,
            -0.01,
            0.045
          ],
          "radius": 0.154,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            -0.025,
            0.055
          ],
          "radius": 0.154,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.095,
            -0.035,
            0.0
          ],
          "radius": 0.142,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.05,
            -0.035,
            0.015
          ],
          "radius": 0.178,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.21,
            -0.045,
            0.02
          ],
          "radius": 0.172,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c281d26": {
      "sourceAddress": "0x0c281d26",
      "sourceSha256": "84296141deb133f34c0a14085e5d1b41af20e876e99dcd811d3140bd542ca1c9",
      "records": [
        {
          "localPosition": [
            -0.02,
            0.02,
            -0.025
          ],
          "radius": 0.129,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            0.015,
            -0.025
          ],
          "radius": 0.136,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.155,
            0.015,
            -0.015
          ],
          "radius": 0.109,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            -0.015
          ],
          "radius": 0.133,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            -0.025,
            0.0
          ],
          "radius": 0.114,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.02,
            0.02,
            0.025
          ],
          "radius": 0.129,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.055,
            0.015,
            0.025
          ],
          "radius": 0.136,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.155,
            0.015,
            0.015
          ],
          "radius": 0.119,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            0.0
          ],
          "radius": 0.126,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.045,
            -0.015,
            0.0
          ],
          "radius": 0.115,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.045,
            -0.015,
            0.0
          ],
          "radius": 0.115,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.21,
            -0.05,
            0.0
          ],
          "radius": 0.106,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.355,
            -0.02,
            0.0
          ],
          "radius": 0.095,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            -0.01,
            -0.095,
            0.005
          ],
          "radius": 0.107,
          "controllerType": 27,
          "collisionMaskBit": 32768
        }
      ]
    },
    "0x0c281dbc": {
      "sourceAddress": "0x0c281dbc",
      "sourceSha256": "8e4788b4b9fb6889f1033fee3b274a5a3f1e4afbb09ff4e9c4d4cb772309935c",
      "records": [
        {
          "localPosition": [
            -0.02,
            0.02,
            -0.025
          ],
          "radius": 0.129,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            0.015,
            -0.025
          ],
          "radius": 0.136,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.155,
            0.015,
            -0.015
          ],
          "radius": 0.139,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            -0.02
          ],
          "radius": 0.129,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.065,
            0.02,
            -0.03
          ],
          "radius": 0.14,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.02,
            0.02,
            0.025
          ],
          "radius": 0.129,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.055,
            0.015,
            0.025
          ],
          "radius": 0.136,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.155,
            0.015,
            0.015
          ],
          "radius": 0.157,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            0.02
          ],
          "radius": 0.142,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.005,
            -0.015,
            0.03
          ],
          "radius": 0.142,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282208": {
      "sourceAddress": "0x0c282208",
      "sourceSha256": "d748ca54e3ea3e59ae381624e6e704ea7428c4f64ee3005cd34e6cc33a3d84a0",
      "records": [
        {
          "localPosition": [
            0.05,
            0.0,
            0.0
          ],
          "radius": 0.189,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.03,
            -0.015,
            -0.03
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            -0.015
          ],
          "radius": 0.188,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.24,
            -0.045,
            -0.01
          ],
          "radius": 0.174,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.03,
            -0.015,
            0.03
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            0.015
          ],
          "radius": 0.188,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.24,
            -0.045,
            0.01
          ],
          "radius": 0.174,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282258": {
      "sourceAddress": "0x0c282258",
      "sourceSha256": "569b26a936f1bf0f014b4cb76d4b9d18d5e15fc62b34830d548971f60e9d8d76",
      "records": [
        {
          "localPosition": [
            0.07,
            -0.03,
            0.06
          ],
          "radius": 0.205,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.07,
            -0.03,
            -0.06
          ],
          "radius": 0.205,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.01,
            -0.015,
            -0.03
          ],
          "radius": 0.196,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            -0.01,
            -0.015
          ],
          "radius": 0.204,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.01,
            -0.015,
            0.03
          ],
          "radius": 0.196,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.175,
            -0.01,
            0.015
          ],
          "radius": 0.204,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c28229e": {
      "sourceAddress": "0x0c28229e",
      "sourceSha256": "870c2058897f5c02959b5340e820ef03531e23cdbb65cbbe2e2b4585d6593824",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.01,
            -0.045
          ],
          "radius": 0.135,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.023,
            0.0,
            -0.045
          ],
          "radius": 0.158,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.105,
            0.0,
            -0.055
          ],
          "radius": 0.176,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.015,
            0.0,
            0.0
          ],
          "radius": 0.19,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.21,
            -0.005,
            0.0
          ],
          "radius": 0.204,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.385,
            -0.02,
            0.0
          ],
          "radius": 0.173,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.0,
            -0.065,
            0.0
          ],
          "radius": 0.202,
          "controllerType": 34,
          "collisionMaskBit": 4096
        },
        {
          "localPosition": [
            -0.03,
            0.01,
            0.045
          ],
          "radius": 0.135,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.023,
            0.0,
            0.045
          ],
          "radius": 0.158,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.105,
            0.0,
            0.055
          ],
          "radius": 0.176,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.015,
            0.0,
            0.0
          ],
          "radius": 0.19,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.21,
            -0.005,
            0.0
          ],
          "radius": 0.204,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.385,
            -0.02,
            0.0
          ],
          "radius": 0.173,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.0,
            -0.065,
            0.0
          ],
          "radius": 0.202,
          "controllerType": 27,
          "collisionMaskBit": 32768
        }
      ]
    },
    "0x0c282334": {
      "sourceAddress": "0x0c282334",
      "sourceSha256": "5423af677fe8528b3dc546e785519036b6fed9089bd497298d50a21795765119",
      "records": [
        {
          "localPosition": [
            -0.03,
            -0.02,
            -0.03
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            -0.02
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.01
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.02
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.152,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            -0.02,
            0.03
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            0.02
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.01
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.02
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.152,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2823de": {
      "sourceAddress": "0x0c2823de",
      "sourceSha256": "a22b08610328158d0b832c4c10d08c7314334bd3a8baed1b1da820b1388a9c5f",
      "records": [
        {
          "localPosition": [
            0.025,
            0.01,
            0.0
          ],
          "radius": 0.259,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.025,
            0.0,
            -0.04
          ],
          "radius": 0.258,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.14,
            -0.02,
            0.02
          ],
          "radius": 0.21,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.235,
            -0.025,
            -0.01
          ],
          "radius": 0.196,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.025,
            0.0,
            0.04
          ],
          "radius": 0.258,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.14,
            -0.02,
            -0.02
          ],
          "radius": 0.21,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.235,
            -0.025,
            0.01
          ],
          "radius": 0.196,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c28242e": {
      "sourceAddress": "0x0c28242e",
      "sourceSha256": "a6fe3713cebc1a9d2a8dfb7582b558daaf8603b3105d31fbb30d40103527db54",
      "records": [
        {
          "localPosition": [
            0.195,
            0.0,
            0.08
          ],
          "radius": 0.188,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.195,
            0.0,
            -0.08
          ],
          "radius": 0.188,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.0,
            0.0
          ],
          "radius": 0.191,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            -0.03,
            -0.02
          ],
          "radius": 0.206,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.155,
            0.0,
            0.0
          ],
          "radius": 0.191,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            -0.03,
            0.02
          ],
          "radius": 0.206,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282474": {
      "sourceAddress": "0x0c282474",
      "sourceSha256": "41f46f454473f55c15de8e5ed48d36a74403eadc5069a3f37f8fc005f953eb92",
      "records": [
        {
          "localPosition": [
            0.155,
            0.05,
            0.08
          ],
          "radius": 0.222,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.05,
            -0.08
          ],
          "radius": 0.222,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.065,
            0.015,
            -0.01
          ],
          "radius": 0.22,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            0.04,
            0.02
          ],
          "radius": 0.21,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.37,
            0.015,
            0.015
          ],
          "radius": 0.208,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.12,
            0.0,
            0.005
          ],
          "radius": 0.218,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.305,
            0.0,
            -0.005
          ],
          "radius": 0.232,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.065,
            0.015,
            0.01
          ],
          "radius": 0.22,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            0.04,
            -0.02
          ],
          "radius": 0.21,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.37,
            0.015,
            -0.015
          ],
          "radius": 0.208,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.12,
            0.0,
            -0.005
          ],
          "radius": 0.218,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.305,
            0.0,
            0.005
          ],
          "radius": 0.232,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2824f6": {
      "sourceAddress": "0x0c2824f6",
      "sourceSha256": "77e9bc31613e030ca9c2ce165693a212f9286adb7be6ae4f918bf24c63174f99",
      "records": [
        {
          "localPosition": [
            0.03,
            0.0,
            -0.02
          ],
          "radius": 0.207,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            0.0,
            0.02
          ],
          "radius": 0.207,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282514": {
      "sourceAddress": "0x0c282514",
      "sourceSha256": "ff121bf0da6106f3a662e0b0b14dc22d50df918c04505dd678c9446ba13f6b62",
      "records": [
        {
          "localPosition": [
            0.17,
            -0.025,
            0.045
          ],
          "radius": 0.169,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.17,
            -0.025,
            -0.045
          ],
          "radius": 0.169,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.105,
            0.01,
            -0.015
          ],
          "radius": 0.17,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.265,
            -0.03,
            -0.03
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.03,
            -0.01,
            -0.025
          ],
          "radius": 0.179,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            -0.025,
            0.0
          ],
          "radius": 0.166,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            -0.005,
            0.0
          ],
          "radius": 0.168,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.44,
            0.015,
            0.0
          ],
          "radius": 0.199,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.105,
            0.01,
            0.015
          ],
          "radius": 0.17,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.265,
            -0.03,
            0.03
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.03,
            -0.01,
            0.025
          ],
          "radius": 0.179,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            -0.025,
            0.0
          ],
          "radius": 0.166,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            -0.005,
            0.0
          ],
          "radius": 0.168,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.44,
            0.015,
            0.0
          ],
          "radius": 0.199,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2825aa": {
      "sourceAddress": "0x0c2825aa",
      "sourceSha256": "eedbe234790f927b8141663337bd823b555b246f73e26491fd37772a82021052",
      "records": [
        {
          "localPosition": [
            0.015,
            0.01,
            -0.025
          ],
          "radius": 0.177,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            0.0,
            0.005
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.015,
            0.01,
            0.025
          ],
          "radius": 0.177,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            0.0,
            -0.005
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2825dc": {
      "sourceAddress": "0x0c2825dc",
      "sourceSha256": "35b8c42b36814b153cb101b47b66b1f88eb13dcdebae7d589fb77bfb758d2582",
      "records": [
        {
          "localPosition": [
            -0.025,
            -0.015,
            0.005
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.02,
            -0.02
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            -0.045,
            -0.01
          ],
          "radius": 0.173,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.09,
            0.0,
            -0.015
          ],
          "radius": 0.186,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.025,
            -0.015,
            -0.005
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.02,
            0.02
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            -0.045,
            0.01
          ],
          "radius": 0.173,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.09,
            0.0,
            0.015
          ],
          "radius": 0.186,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282636": {
      "sourceAddress": "0x0c282636",
      "sourceSha256": "9f79628778f577beb25908f2579d071bbe4028ea92e880dcfae5f14a04973409",
      "records": [
        {
          "localPosition": [
            0.135,
            0.0,
            0.055
          ],
          "radius": 0.173,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.135,
            0.0,
            -0.055
          ],
          "radius": 0.173,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.105,
            0.01,
            -0.02
          ],
          "radius": 0.184,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.015,
            -0.01
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.02,
            -0.015
          ],
          "radius": 0.195,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.105,
            0.01,
            0.02
          ],
          "radius": 0.184,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.015,
            0.01
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.02,
            0.015
          ],
          "radius": 0.195,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282690": {
      "sourceAddress": "0x0c282690",
      "sourceSha256": "f8132e59a06c3b364f55f994249798f0e48285c9e1a15c1e8525e0d514efdd37",
      "records": [
        {
          "localPosition": [
            0.095,
            0.0,
            -0.04
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.21,
            -0.005,
            -0.05
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.03,
            -0.005,
            -0.035
          ],
          "radius": 0.16,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.105,
            -0.02,
            -0.04
          ],
          "radius": 0.167,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.215,
            -0.02,
            -0.01
          ],
          "radius": 0.167,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.095,
            0.0,
            0.04
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.21,
            -0.005,
            0.05
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.03,
            -0.005,
            0.035
          ],
          "radius": 0.16,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.105,
            -0.02,
            0.04
          ],
          "radius": 0.167,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.215,
            -0.02,
            0.01
          ],
          "radius": 0.167,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2826fe": {
      "sourceAddress": "0x0c2826fe",
      "sourceSha256": "baf48bb5877545c1ed50ec7855ea7bbd3953ada9ce8e684902aa367e5661c165",
      "records": [
        {
          "localPosition": [
            0.065,
            -0.01,
            0.035
          ],
          "radius": 0.163,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.065,
            -0.01,
            -0.035
          ],
          "radius": 0.163,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.01,
            -0.02,
            -0.03
          ],
          "radius": 0.171,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.17,
            -0.01,
            -0.02
          ],
          "radius": 0.167,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.01,
            -0.02,
            0.03
          ],
          "radius": 0.171,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.17,
            -0.01,
            0.02
          ],
          "radius": 0.167,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282744": {
      "sourceAddress": "0x0c282744",
      "sourceSha256": "311248eb09a21ae07fc87441ec31c6038637fb1e8b20326448800d01aff2311a",
      "records": [
        {
          "localPosition": [
            0.0,
            -0.01,
            -0.04
          ],
          "radius": 0.197,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            -0.015,
            -0.02
          ],
          "radius": 0.205,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.235,
            -0.02,
            -0.01
          ],
          "radius": 0.205,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.015,
            0.0,
            0.0
          ],
          "radius": 0.185,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.0,
            -0.01,
            0.04
          ],
          "radius": 0.197,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            -0.015,
            0.02
          ],
          "radius": 0.205,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.235,
            -0.02,
            0.01
          ],
          "radius": 0.205,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.015,
            0.0,
            0.0
          ],
          "radius": 0.185,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28279e": {
      "sourceAddress": "0x0c28279e",
      "sourceSha256": "b584daa60d55be4b72ec8d4d18b9d6a895232467fab56bc4afa2aa596832a4e3",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.01,
            -0.045
          ],
          "radius": 0.135,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.023,
            0.0,
            -0.045
          ],
          "radius": 0.158,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.12,
            -0.015,
            -0.04
          ],
          "radius": 0.163,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.11,
            -0.035,
            0.005
          ],
          "radius": 0.132,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.035,
            -0.02,
            -0.03
          ],
          "radius": 0.177,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.245,
            -0.02,
            -0.03
          ],
          "radius": 0.173,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            0.01,
            0.045
          ],
          "radius": 0.135,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.023,
            0.0,
            0.045
          ],
          "radius": 0.158,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.12,
            -0.015,
            0.04
          ],
          "radius": 0.163,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.11,
            -0.035,
            -0.005
          ],
          "radius": 0.132,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.035,
            -0.02,
            0.03
          ],
          "radius": 0.177,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.245,
            -0.02,
            0.03
          ],
          "radius": 0.173,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282820": {
      "sourceAddress": "0x0c282820",
      "sourceSha256": "61db23fe5a0a3047f3a9ebdd6db0894ed234961a1d07a6e28eb55bb30a74555d",
      "records": [
        {
          "localPosition": [
            0.085,
            0.015,
            0.04
          ],
          "radius": 0.153,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.085,
            0.015,
            -0.04
          ],
          "radius": 0.153,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.005,
            0.005,
            -0.005
          ],
          "radius": 0.161,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.085,
            0.01,
            -0.01
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.13,
            -0.015,
            0.005
          ],
          "radius": 0.145,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.01,
            -0.025,
            -0.025
          ],
          "radius": 0.155,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.13,
            -0.02,
            -0.04
          ],
          "radius": 0.172,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.005,
            0.005,
            0.005
          ],
          "radius": 0.161,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.085,
            0.01,
            0.01
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.13,
            -0.015,
            -0.005
          ],
          "radius": 0.145,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.01,
            -0.025,
            0.025
          ],
          "radius": 0.155,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.13,
            -0.02,
            0.04
          ],
          "radius": 0.172,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2828a2": {
      "sourceAddress": "0x0c2828a2",
      "sourceSha256": "d0c7465938c2bb95dc7ae100bae606b8e872600588fba362defce3a2742b9da1",
      "records": [
        {
          "localPosition": [
            0.075,
            -0.005,
            0.0
          ],
          "radius": 0.112,
          "controllerType": 16,
          "collisionMaskBit": 16
        },
        {
          "localPosition": [
            0.21,
            -0.01,
            0.0
          ],
          "radius": 0.108,
          "controllerType": 16,
          "collisionMaskBit": 16
        },
        {
          "localPosition": [
            0.075,
            -0.005,
            0.0
          ],
          "radius": 0.112,
          "controllerType": 10,
          "collisionMaskBit": 128
        },
        {
          "localPosition": [
            0.21,
            -0.01,
            0.0
          ],
          "radius": 0.108,
          "controllerType": 10,
          "collisionMaskBit": 128
        },
        {
          "localPosition": [
            0.025,
            0.01,
            0.0
          ],
          "radius": 0.259,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.025,
            0.0,
            -0.04
          ],
          "radius": 0.258,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            -0.01,
            0.05
          ],
          "radius": 0.24,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.265,
            -0.025,
            0.05
          ],
          "radius": 0.251,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.035,
            -0.025,
            0.045
          ],
          "radius": 0.239,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.185,
            -0.005,
            0.0
          ],
          "radius": 0.223,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.335,
            -0.01,
            0.0
          ],
          "radius": 0.231,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.025,
            0.0,
            0.04
          ],
          "radius": 0.258,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            -0.01,
            -0.05
          ],
          "radius": 0.24,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.265,
            -0.025,
            -0.05
          ],
          "radius": 0.251,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.035,
            -0.025,
            -0.045
          ],
          "radius": 0.239,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.185,
            -0.005,
            0.0
          ],
          "radius": 0.223,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.335,
            -0.01,
            0.0
          ],
          "radius": 0.231,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282956": {
      "sourceAddress": "0x0c282956",
      "sourceSha256": "39aa32f970f0e3e5fa314184d2d1bef3b9c17d6e4e918644c085b38b68bdbef0",
      "records": [
        {
          "localPosition": [
            0.195,
            0.0,
            0.08
          ],
          "radius": 0.209,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.195,
            0.0,
            -0.08
          ],
          "radius": 0.209,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.195,
            -0.025,
            0.015
          ],
          "radius": 0.2,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.295,
            -0.005,
            0.035
          ],
          "radius": 0.168,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.165,
            -0.025,
            0.0
          ],
          "radius": 0.172,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.335,
            -0.03,
            0.0
          ],
          "radius": 0.164,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.45,
            -0.02,
            0.0
          ],
          "radius": 0.234,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.195,
            -0.025,
            -0.015
          ],
          "radius": 0.195,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.295,
            0.0,
            -0.035
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.165,
            -0.025,
            0.0
          ],
          "radius": 0.172,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.335,
            -0.03,
            0.0
          ],
          "radius": 0.164,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.45,
            -0.02,
            0.0
          ],
          "radius": 0.234,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2829d8": {
      "sourceAddress": "0x0c2829d8",
      "sourceSha256": "b668ac8bd5c72ae32822044a1695376dc12fd9112c9850d5eed14303afddc79d",
      "records": [
        {
          "localPosition": [
            0.005,
            0.01,
            -0.055
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            0.01,
            -0.045
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.17,
            0.0,
            -0.035
          ],
          "radius": 0.194,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.005,
            0.01,
            0.055
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            0.01,
            0.045
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.17,
            0.0,
            0.035
          ],
          "radius": 0.194,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282a1e": {
      "sourceAddress": "0x0c282a1e",
      "sourceSha256": "0c2f74856ddf1d9537e4942715686b832d9615eace2908693948b5d005f7ccf5",
      "records": [
        {
          "localPosition": [
            0.1,
            0.01,
            -0.01
          ],
          "radius": 0.213,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.045,
            0.01,
            -0.03
          ],
          "radius": 0.207,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            0.01,
            0.03
          ],
          "radius": 0.207,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282a46": {
      "sourceAddress": "0x0c282a46",
      "sourceSha256": "0e76a871552322db2be9734eaa5829033b039c160a7c6e7c9787770e3c0d8995",
      "records": [
        {
          "localPosition": [
            0.065,
            -0.025,
            -0.03
          ],
          "radius": 0.233,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            -0.035,
            -0.02
          ],
          "radius": 0.228,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.065,
            -0.025,
            0.03
          ],
          "radius": 0.233,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            -0.035,
            0.02
          ],
          "radius": 0.228,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282a78": {
      "sourceAddress": "0x0c282a78",
      "sourceSha256": "263aaf862be0a5abc3b41e291d62b673d6e83c4382a5379964a498d1320d2931",
      "records": [
        {
          "localPosition": [
            0.025,
            0.0,
            -0.07
          ],
          "radius": 0.173,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.14,
            -0.005,
            -0.055
          ],
          "radius": 0.163,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.285,
            -0.025,
            -0.06
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.09,
            -0.035,
            -0.055
          ],
          "radius": 0.242,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.35,
            0.03,
            -0.035
          ],
          "radius": 0.232,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.025,
            0.0,
            0.07
          ],
          "radius": 0.173,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.14,
            -0.005,
            0.055
          ],
          "radius": 0.163,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.285,
            -0.025,
            0.06
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.09,
            -0.035,
            0.055
          ],
          "radius": 0.242,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.35,
            0.03,
            0.035
          ],
          "radius": 0.232,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282ae6": {
      "sourceAddress": "0x0c282ae6",
      "sourceSha256": "00e289e100042f8fd9251ff130344765528516bb8a2552107d761076c3cb8d07",
      "records": [
        {
          "localPosition": [
            0.15,
            0.015,
            0.075
          ],
          "radius": 0.224,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.15,
            0.015,
            -0.075
          ],
          "radius": 0.224,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            -0.015,
            -0.045
          ],
          "radius": 0.24,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            -0.025,
            -0.04
          ],
          "radius": 0.241,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.155,
            -0.015,
            0.045
          ],
          "radius": 0.24,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            -0.025,
            0.04
          ],
          "radius": 0.241,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282b2c": {
      "sourceAddress": "0x0c282b2c",
      "sourceSha256": "881121293ec011b4199a04016419d4fb99c57e2dc80a7e6c835daaf1b4070aae",
      "records": [
        {
          "localPosition": [
            0.0,
            0.015,
            -0.03
          ],
          "radius": 0.203,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.065,
            0.015,
            -0.02
          ],
          "radius": 0.194,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            0.015,
            -0.01
          ],
          "radius": 0.181,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.24,
            0.0,
            -0.02
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.015,
            0.03
          ],
          "radius": 0.203,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.065,
            0.015,
            0.02
          ],
          "radius": 0.194,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            0.015,
            0.01
          ],
          "radius": 0.181,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.24,
            0.0,
            0.02
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282b86": {
      "sourceAddress": "0x0c282b86",
      "sourceSha256": "7ca4fd29084dca82be617575715860f60fd16090ab166fb7cd11b102054bf478",
      "records": [
        {
          "localPosition": [
            0.035,
            -0.005,
            -0.03
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.115,
            0.0,
            -0.01
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.225,
            0.0,
            -0.05
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            -0.005,
            0.005
          ],
          "radius": 0.19,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.04,
            0.045,
            -0.015
          ],
          "radius": 0.177,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.035,
            -0.005,
            0.03
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.115,
            0.0,
            0.01
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.225,
            0.0,
            0.05
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            -0.005,
            -0.005
          ],
          "radius": 0.19,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.04,
            0.045,
            0.015
          ],
          "radius": 0.177,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282bf4": {
      "sourceAddress": "0x0c282bf4",
      "sourceSha256": "41d92fcd30a281a7668307bb0f7e8ee3de3a9be9102e1f3ee359711cac8f6ba3",
      "records": [
        {
          "localPosition": [
            0.035,
            0.025,
            -0.09
          ],
          "radius": 0.148,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.143,
            0.01,
            -0.04
          ],
          "radius": 0.151,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            -0.065,
            -0.025
          ],
          "radius": 0.201,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.09,
            -0.035,
            -0.035
          ],
          "radius": 0.183,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.07,
            -0.005,
            -0.045
          ],
          "radius": 0.168,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.325,
            -0.02,
            -0.045
          ],
          "radius": 0.148,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.035,
            0.025,
            0.09
          ],
          "radius": 0.148,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.143,
            0.01,
            0.04
          ],
          "radius": 0.151,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            -0.065,
            0.025
          ],
          "radius": 0.201,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.105,
            -0.035,
            0.035
          ],
          "radius": 0.183,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.07,
            -0.005,
            0.045
          ],
          "radius": 0.168,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.325,
            -0.02,
            0.045
          ],
          "radius": 0.148,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282c76": {
      "sourceAddress": "0x0c282c76",
      "sourceSha256": "f7f6f639724bc490d07fcfe582188efb0d3e6be876a9dd7ca4b359c3e428abe6",
      "records": [
        {
          "localPosition": [
            0.025,
            0.005,
            -0.02
          ],
          "radius": 0.173,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.043,
            -0.02,
            -0.04
          ],
          "radius": 0.162,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.165,
            -0.02,
            -0.025
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            -0.035,
            -0.035
          ],
          "radius": 0.165,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.025,
            0.005,
            0.02
          ],
          "radius": 0.173,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.043,
            -0.02,
            0.04
          ],
          "radius": 0.162,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.165,
            -0.02,
            0.025
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.045,
            -0.035,
            0.035
          ],
          "radius": 0.165,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282cd0": {
      "sourceAddress": "0x0c282cd0",
      "sourceSha256": "007cca9ce105978921fb210e3a83bf671e4212cb0ece2500abb2de2c109d6c91",
      "records": [
        {
          "localPosition": [
            -0.015,
            0.0,
            -0.03
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.095,
            -0.015,
            -0.02
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.005,
            -0.01
          ],
          "radius": 0.167,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            0.0,
            0.03
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.095,
            -0.015,
            0.02
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.005,
            0.01
          ],
          "radius": 0.167,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282d16": {
      "sourceAddress": "0x0c282d16",
      "sourceSha256": "a0e376318ffc3fb065dfcf3e6ea82440788a211d55831a7322738acd53fc7c00",
      "records": [
        {
          "localPosition": [
            0.01,
            0.035,
            -0.045
          ],
          "radius": 0.166,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            0.01,
            -0.035
          ],
          "radius": 0.167,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.135,
            0.015,
            -0.035
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.22,
            0.015,
            -0.05
          ],
          "radius": 0.207,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.06,
            0.0,
            -0.04
          ],
          "radius": 0.199,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.08,
            0.005,
            -0.055
          ],
          "radius": 0.219,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.215,
            0.01,
            -0.025
          ],
          "radius": 0.208,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            0.01,
            -0.035
          ],
          "radius": 0.215,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.01,
            0.035,
            0.045
          ],
          "radius": 0.166,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.045,
            0.01,
            0.035
          ],
          "radius": 0.167,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.135,
            0.015,
            0.035
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.22,
            0.015,
            0.05
          ],
          "radius": 0.207,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.06,
            0.0,
            0.04
          ],
          "radius": 0.199,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.08,
            0.005,
            0.055
          ],
          "radius": 0.219,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.215,
            0.01,
            0.025
          ],
          "radius": 0.208,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            0.01,
            0.035
          ],
          "radius": 0.215,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            -0.015,
            0.025,
            -0.03
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.105,
            0.015,
            -0.02
          ],
          "radius": 0.178,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            0.025,
            0.03
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.105,
            0.015,
            0.02
          ],
          "radius": 0.178,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282db6": {
      "sourceAddress": "0x0c282db6",
      "sourceSha256": "f03a69cca7ba14888d0e2f06547441175093c45b2f197f8731d36cac82c11ce3",
      "records": [
        {
          "localPosition": [
            -0.015,
            0.025,
            -0.03
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.105,
            0.015,
            -0.02
          ],
          "radius": 0.178,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            0.025,
            0.03
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.105,
            0.015,
            0.02
          ],
          "radius": 0.178,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282de8": {
      "sourceAddress": "0x0c282de8",
      "sourceSha256": "a4d0c0572cc39b18952602c2195f8d2986e854d8ba7253465ec0cb6b9d074145",
      "records": [
        {
          "localPosition": [
            -0.08,
            -0.02,
            -0.03
          ],
          "radius": 0.201,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.07,
            -0.04,
            -0.02
          ],
          "radius": 0.198,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.185,
            -0.03,
            -0.01
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.005,
            -0.05,
            0.0
          ],
          "radius": 0.187,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.08,
            -0.02,
            0.03
          ],
          "radius": 0.201,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.07,
            -0.04,
            0.02
          ],
          "radius": 0.198,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.185,
            -0.03,
            0.01
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.005,
            -0.05,
            0.0
          ],
          "radius": 0.187,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282e42": {
      "sourceAddress": "0x0c282e42",
      "sourceSha256": "fb15b4750ded4a8940d8482332ac71a0e7453e5ec13bd78c01bb9408af64846f",
      "records": [
        {
          "localPosition": [
            0.155,
            0.0,
            0.075
          ],
          "radius": 0.193,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.0,
            -0.075
          ],
          "radius": 0.193,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.115,
            0.0,
            -0.015
          ],
          "radius": 0.214,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.235,
            0.005,
            -0.015
          ],
          "radius": 0.205,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            -0.05,
            0.0
          ],
          "radius": 0.222,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.115,
            0.0,
            0.015
          ],
          "radius": 0.214,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.235,
            0.005,
            0.015
          ],
          "radius": 0.205,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.075,
            -0.05,
            0.0
          ],
          "radius": 0.222,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282e9c": {
      "sourceAddress": "0x0c282e9c",
      "sourceSha256": "e146979da9112e333a082bf2604ef5b33de092b6e074f973dad2ba56d6620781",
      "records": [
        {
          "localPosition": [
            0.14,
            -0.025,
            0.05
          ],
          "radius": 0.151,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.14,
            -0.025,
            -0.05
          ],
          "radius": 0.151,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.055,
            -0.01,
            -0.03
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            -0.01,
            -0.04
          ],
          "radius": 0.17,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            -0.01,
            0.03
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.175,
            -0.01,
            0.04
          ],
          "radius": 0.17,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282ee2": {
      "sourceAddress": "0x0c282ee2",
      "sourceSha256": "051273bfdc54a435db9aea16b6f30a22f13f3604028deef1a27c33d3a9c0bf3a",
      "records": [
        {
          "localPosition": [
            0.18,
            0.0,
            0.08
          ],
          "radius": 0.171,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.18,
            0.0,
            -0.08
          ],
          "radius": 0.171,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.015,
            0.0,
            -0.025
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.06,
            -0.01,
            -0.035
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.185,
            -0.02,
            -0.025
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            0.0,
            0.025
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.06,
            -0.01,
            0.035
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.185,
            -0.02,
            0.025
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282f3c": {
      "sourceAddress": "0x0c282f3c",
      "sourceSha256": "68863661103e93538d3f1b3525550d78602ba87eed8b47ceff7771f4d7729116",
      "records": [
        {
          "localPosition": [
            0.215,
            0.0,
            0.085
          ],
          "radius": 0.179,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.215,
            0.0,
            -0.085
          ],
          "radius": 0.179,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.105,
            0.0,
            -0.005
          ],
          "radius": 0.181,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.235,
            0.005,
            -0.02
          ],
          "radius": 0.188,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.005,
            -0.04,
            0.0
          ],
          "radius": 0.192,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.105,
            0.0,
            0.005
          ],
          "radius": 0.181,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.235,
            0.005,
            0.02
          ],
          "radius": 0.188,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.005,
            -0.04,
            0.0
          ],
          "radius": 0.192,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c282f96": {
      "sourceAddress": "0x0c282f96",
      "sourceSha256": "64d9a49155c26abc8b19b6223d1ddb1e8055b26bb56dd91f036a31a9769ab4e7",
      "records": [
        {
          "localPosition": [
            -0.035,
            0.01,
            0.01
          ],
          "radius": 0.159,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.06,
            0.005,
            -0.005
          ],
          "radius": 0.159,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.01
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.035,
            0.01,
            -0.01
          ],
          "radius": 0.159,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.06,
            0.005,
            0.005
          ],
          "radius": 0.159,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.01
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c282fdc": {
      "sourceAddress": "0x0c282fdc",
      "sourceSha256": "632557b03ed914fb19885fa6cd3cd7fca59a30780854b7267e0f36de6b6f73cd",
      "records": [
        {
          "localPosition": [
            0.01,
            0.005,
            -0.015
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.13,
            0.0,
            -0.055
          ],
          "radius": 0.193,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.22,
            -0.005,
            -0.03
          ],
          "radius": 0.203,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.01,
            0.0,
            -0.025
          ],
          "radius": 0.212,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.13,
            -0.01,
            -0.05
          ],
          "radius": 0.222,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.29,
            0.005,
            -0.035
          ],
          "radius": 0.228,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.01,
            0.005,
            0.015
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.13,
            0.0,
            0.055
          ],
          "radius": 0.193,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.22,
            -0.005,
            0.03
          ],
          "radius": 0.203,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.01,
            0.0,
            0.025
          ],
          "radius": 0.212,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.13,
            -0.01,
            0.05
          ],
          "radius": 0.222,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.29,
            0.005,
            0.035
          ],
          "radius": 0.228,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28305e": {
      "sourceAddress": "0x0c28305e",
      "sourceSha256": "1539368f53b20447a2166949088b415daabfdf5f8acb4bdcfaa76d11a7930ff6",
      "records": [
        {
          "localPosition": [
            0.045,
            0.015,
            -0.015
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.13,
            -0.015,
            -0.03
          ],
          "radius": 0.184,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            -0.015,
            -0.01
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            0.015,
            0.015
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.13,
            -0.015,
            0.03
          ],
          "radius": 0.184,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            -0.015,
            0.01
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2830a4": {
      "sourceAddress": "0x0c2830a4",
      "sourceSha256": "820bdd67b2d7912a7b1e84d48065fd0513cd68ea20374e9010e8023a9759cfa3",
      "records": [
        {
          "localPosition": [
            -0.075,
            0.02,
            -0.04
          ],
          "radius": 0.188,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            -0.005,
            -0.07
          ],
          "radius": 0.207,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.145,
            -0.025,
            -0.05
          ],
          "radius": 0.201,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.09,
            -0.03,
            -0.035
          ],
          "radius": 0.192,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.025,
            -0.03,
            -0.03
          ],
          "radius": 0.189,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.075,
            0.02,
            0.04
          ],
          "radius": 0.188,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.03,
            -0.005,
            0.07
          ],
          "radius": 0.207,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.145,
            -0.025,
            0.05
          ],
          "radius": 0.201,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.09,
            -0.03,
            0.035
          ],
          "radius": 0.192,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.025,
            -0.03,
            0.03
          ],
          "radius": 0.189,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283112": {
      "sourceAddress": "0x0c283112",
      "sourceSha256": "afef683a499b42fe95efc9330df5f0b116a7dcd927866a42378a2d1913eef687",
      "records": [
        {
          "localPosition": [
            -0.02,
            0.015,
            -0.015
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            0.005,
            -0.02
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.01
          ],
          "radius": 0.184,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.02,
            0.015,
            0.015
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            0.005,
            0.02
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.01
          ],
          "radius": 0.184,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283158": {
      "sourceAddress": "0x0c283158",
      "sourceSha256": "4f22c15d61f40bb7962e9ab0a0627de5fdda43ee622c719338f0802aea14e32a",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.005,
            -0.03
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.025,
            -0.01,
            -0.05
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.16,
            -0.005,
            -0.04
          ],
          "radius": 0.168,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.03,
            0.005,
            0.03
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.025,
            -0.01,
            0.05
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.16,
            -0.005,
            0.04
          ],
          "radius": 0.168,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c28319e": {
      "sourceAddress": "0x0c28319e",
      "sourceSha256": "855adf319036ccf8a9d64651a094c16c70e824c43fe8706728da2c233bf1ec81",
      "records": [
        {
          "localPosition": [
            0.15,
            0.01,
            -0.045
          ],
          "radius": 0.15,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.15,
            0.01,
            0.045
          ],
          "radius": 0.15,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.115,
            0.005,
            -0.02
          ],
          "radius": 0.148,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.245,
            0.01,
            -0.03
          ],
          "radius": 0.133,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.365,
            -0.01,
            -0.02
          ],
          "radius": 0.125,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            -0.015,
            -0.025
          ],
          "radius": 0.134,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.115,
            0.005,
            0.02
          ],
          "radius": 0.148,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.245,
            0.01,
            0.03
          ],
          "radius": 0.133,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.365,
            -0.01,
            0.02
          ],
          "radius": 0.125,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.075,
            -0.015,
            0.025
          ],
          "radius": 0.134,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28320c": {
      "sourceAddress": "0x0c28320c",
      "sourceSha256": "46ca56c07ef2773cecede5b2baab40a411bcd9907d0aceca8f40e0ac00eb87fc",
      "records": [
        {
          "localPosition": [
            -0.05,
            0.01,
            -0.03
          ],
          "radius": 0.19,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            -0.005,
            -0.02
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.015,
            -0.01
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.05,
            0.01,
            0.03
          ],
          "radius": 0.19,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.055,
            -0.005,
            0.02
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.015,
            0.01
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283252": {
      "sourceAddress": "0x0c283252",
      "sourceSha256": "6809c7bfa8ddfc54211035abef21574c571b7704345c7b3508797214b29b749e",
      "records": [
        {
          "localPosition": [
            -0.03,
            -0.035,
            -0.005
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.005,
            -0.035
          ],
          "radius": 0.177,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.035
          ],
          "radius": 0.175,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.03,
            -0.035,
            0.005
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.005,
            0.035
          ],
          "radius": 0.177,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.035
          ],
          "radius": 0.175,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283298": {
      "sourceAddress": "0x0c283298",
      "sourceSha256": "28713cbac18733a41e6212f9f107b2ecde01907418ffe7ad2bc8f9e5ae3d68c5",
      "records": [
        {
          "localPosition": [
            0.015,
            0.01,
            -0.03
          ],
          "radius": 0.236,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            -0.01,
            -0.02
          ],
          "radius": 0.24,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            -0.01
          ],
          "radius": 0.237,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            0.0,
            -0.005
          ],
          "radius": 0.218,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.23,
            0.0,
            -0.01
          ],
          "radius": 0.212,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.015,
            0.01,
            0.03
          ],
          "radius": 0.236,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.175,
            -0.01,
            0.02
          ],
          "radius": 0.24,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            0.01
          ],
          "radius": 0.237,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.055,
            0.0,
            0.005
          ],
          "radius": 0.218,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.23,
            0.0,
            0.01
          ],
          "radius": 0.212,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283306": {
      "sourceAddress": "0x0c283306",
      "sourceSha256": "f5a1c1e4feebd92b2c6497ff88792b44e554e14f314eae6adecf00af826be92d",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.01,
            -0.045
          ],
          "radius": 0.135,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.073,
            -0.015,
            -0.06
          ],
          "radius": 0.142,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.19,
            -0.015,
            -0.08
          ],
          "radius": 0.17,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.04,
            -0.025,
            -0.04
          ],
          "radius": 0.154,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.14,
            -0.01,
            -0.025
          ],
          "radius": 0.184,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.35,
            0.005,
            0.0
          ],
          "radius": 0.179,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            0.01,
            0.045
          ],
          "radius": 0.135,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.073,
            -0.015,
            0.06
          ],
          "radius": 0.142,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.19,
            -0.015,
            0.08
          ],
          "radius": 0.17,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.04,
            -0.025,
            0.04
          ],
          "radius": 0.154,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.14,
            -0.01,
            0.025
          ],
          "radius": 0.184,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.35,
            0.005,
            0.0
          ],
          "radius": 0.179,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283388": {
      "sourceAddress": "0x0c283388",
      "sourceSha256": "e0d2b0a0a5660f90652ae79956fe04f0f0c3ab42eccfcf90304820f0a22b2b76",
      "records": [
        {
          "localPosition": [
            0.19,
            0.01,
            0.08
          ],
          "radius": 0.226,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.19,
            0.01,
            -0.08
          ],
          "radius": 0.226,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.135,
            0.02,
            -0.015
          ],
          "radius": 0.223,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            0.025,
            0.0
          ],
          "radius": 0.227,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.005,
            0.005,
            0.0
          ],
          "radius": 0.234,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            -0.005,
            -0.035
          ],
          "radius": 0.267,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.325,
            0.0,
            -0.02
          ],
          "radius": 0.219,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.135,
            0.02,
            0.015
          ],
          "radius": 0.223,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            0.025,
            0.0
          ],
          "radius": 0.227,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.005,
            0.005,
            0.0
          ],
          "radius": 0.234,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            -0.005,
            0.035
          ],
          "radius": 0.267,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.325,
            0.0,
            0.02
          ],
          "radius": 0.219,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28340a": {
      "sourceAddress": "0x0c28340a",
      "sourceSha256": "3a182a237be04335341fa786585efbb1987beae04523308589e0fd7c92534bec",
      "records": [
        {
          "localPosition": [
            0.19,
            -0.015,
            0.07
          ],
          "radius": 0.251,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.19,
            -0.015,
            -0.07
          ],
          "radius": 0.251,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.14,
            -0.015,
            -0.03
          ],
          "radius": 0.232,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.315,
            -0.035,
            -0.02
          ],
          "radius": 0.241,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.14,
            -0.015,
            0.03
          ],
          "radius": 0.232,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.315,
            -0.035,
            0.02
          ],
          "radius": 0.241,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283450": {
      "sourceAddress": "0x0c283450",
      "sourceSha256": "ebce2092cbf76c892dfaf601dbaffbb53c39841c9960ebe711aa33106d32ebbb",
      "records": [
        {
          "localPosition": [
            0.045,
            -0.005,
            -0.05
          ],
          "radius": 0.152,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.168,
            -0.015,
            -0.045
          ],
          "radius": 0.166,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            0.0,
            -0.05
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            -0.02,
            -0.025
          ],
          "radius": 0.175,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.19,
            -0.02,
            -0.03
          ],
          "radius": 0.179,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.045,
            -0.005,
            0.05
          ],
          "radius": 0.152,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.168,
            -0.015,
            0.045
          ],
          "radius": 0.166,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            0.0,
            0.05
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.03,
            -0.02,
            0.025
          ],
          "radius": 0.175,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.19,
            -0.02,
            0.03
          ],
          "radius": 0.179,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2834be": {
      "sourceAddress": "0x0c2834be",
      "sourceSha256": "e9d9e3d25fe3fbbb4e912345a1497cd03dbc687a0a014df392cd61aa5391d67f",
      "records": [
        {
          "localPosition": [
            0.19,
            -0.005,
            0.07
          ],
          "radius": 0.175,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.19,
            -0.005,
            -0.07
          ],
          "radius": 0.175,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.1,
            -0.02,
            -0.025
          ],
          "radius": 0.183,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            -0.02,
            -0.01
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.02,
            0.025
          ],
          "radius": 0.183,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            -0.02,
            0.01
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283504": {
      "sourceAddress": "0x0c283504",
      "sourceSha256": "222e9cb727b2c0dcdd8914a112037776c87d3c82feea2549c168fedb1d09c2ca",
      "records": [
        {
          "localPosition": [
            0.045,
            0.005,
            -0.05
          ],
          "radius": 0.24,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.265,
            -0.025,
            -0.03
          ],
          "radius": 0.214,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            -0.02,
            -0.035
          ],
          "radius": 0.212,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.34,
            0.015,
            -0.01
          ],
          "radius": 0.195,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.045,
            0.005,
            0.05
          ],
          "radius": 0.24,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.265,
            -0.025,
            0.03
          ],
          "radius": 0.214,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            -0.02,
            0.035
          ],
          "radius": 0.212,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.34,
            0.015,
            0.01
          ],
          "radius": 0.195,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28355e": {
      "sourceAddress": "0x0c28355e",
      "sourceSha256": "5ddc35bf6a701d3a4e5a1f8747739e36600ef27fd85d3794da67321c07a14bff",
      "records": [
        {
          "localPosition": [
            0.155,
            -0.005,
            0.04
          ],
          "radius": 0.15,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            -0.005,
            -0.04
          ],
          "radius": 0.15,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.1,
            0.0,
            -0.03
          ],
          "radius": 0.174,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.21,
            0.01,
            -0.02
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            0.0,
            0.03
          ],
          "radius": 0.174,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.21,
            0.01,
            0.02
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2835a4": {
      "sourceAddress": "0x0c2835a4",
      "sourceSha256": "3fba75f308518ffb4bf13b714d8a8a3dc4d5caeff8b064b655336aa9d0fcf013",
      "records": [
        {
          "localPosition": [
            0.02,
            0.0,
            -0.035
          ],
          "radius": 0.149,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.14,
            -0.005,
            -0.045
          ],
          "radius": 0.162,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.27,
            -0.015,
            -0.04
          ],
          "radius": 0.163,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.025,
            -0.055
          ],
          "radius": 0.171,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.1,
            -0.02,
            -0.055
          ],
          "radius": 0.181,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.18,
            -0.015,
            -0.055
          ],
          "radius": 0.188,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.415,
            0.02,
            -0.015
          ],
          "radius": 0.174,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.02,
            0.0,
            0.035
          ],
          "radius": 0.149,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.14,
            -0.005,
            0.045
          ],
          "radius": 0.162,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.27,
            -0.015,
            0.04
          ],
          "radius": 0.163,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.025,
            0.055
          ],
          "radius": 0.171,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.1,
            -0.02,
            0.055
          ],
          "radius": 0.181,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.18,
            -0.015,
            0.055
          ],
          "radius": 0.188,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.415,
            0.02,
            0.015
          ],
          "radius": 0.174,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28363a": {
      "sourceAddress": "0x0c28363a",
      "sourceSha256": "5de07436c5fbf802eb0de214fc2df337fa2ff7532cf5c9b1b95fea9effd2ab15",
      "records": [
        {
          "localPosition": [
            0.065,
            0.01,
            0.045
          ],
          "radius": 0.138,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.065,
            0.01,
            -0.045
          ],
          "radius": 0.138,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.035,
            0.015,
            -0.035
          ],
          "radius": 0.161,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.165,
            0.005,
            -0.055
          ],
          "radius": 0.189,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.035,
            0.015,
            0.035
          ],
          "radius": 0.161,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.165,
            0.005,
            0.055
          ],
          "radius": 0.189,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283680": {
      "sourceAddress": "0x0c283680",
      "sourceSha256": "86d15f65c52e28752e2bbfe24d833a33e88359f27d5d5dde39a22e831d054490",
      "records": [
        {
          "localPosition": [
            -0.005,
            -0.01,
            -0.03
          ],
          "radius": 0.193,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.095,
            -0.01,
            -0.035
          ],
          "radius": 0.2,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            -0.025,
            -0.03
          ],
          "radius": 0.191,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.005,
            -0.01,
            0.03
          ],
          "radius": 0.193,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.095,
            -0.01,
            0.035
          ],
          "radius": 0.2,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            -0.025,
            0.03
          ],
          "radius": 0.191,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2836c6": {
      "sourceAddress": "0x0c2836c6",
      "sourceSha256": "a864e33e3f46c73e76f012d8a15121dd2b0aea080a14c0d6fa283f2750589173",
      "records": [
        {
          "localPosition": [
            0.055,
            0.01,
            -0.03
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            0.0,
            -0.035
          ],
          "radius": 0.184,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.225,
            -0.005,
            -0.01
          ],
          "radius": 0.181,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.33,
            -0.005,
            -0.035
          ],
          "radius": 0.207,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            0.0,
            -0.02
          ],
          "radius": 0.204,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.01,
            -0.005
          ],
          "radius": 0.219,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.275,
            0.0,
            -0.01
          ],
          "radius": 0.24,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.495,
            0.02,
            -0.035
          ],
          "radius": 0.257,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.055,
            0.01,
            0.03
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.035
          ],
          "radius": 0.184,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.225,
            -0.005,
            0.01
          ],
          "radius": 0.181,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.33,
            -0.005,
            0.035
          ],
          "radius": 0.207,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.045,
            0.0,
            0.02
          ],
          "radius": 0.204,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.01,
            0.005
          ],
          "radius": 0.219,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.275,
            0.0,
            0.01
          ],
          "radius": 0.24,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.495,
            0.02,
            0.035
          ],
          "radius": 0.257,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283770": {
      "sourceAddress": "0x0c283770",
      "sourceSha256": "ba912f33a7d904cdb82014917d6dce0fc2ef754ea2c944beaf2c558d62782edd",
      "records": [
        {
          "localPosition": [
            0.06,
            -0.025,
            0.035
          ],
          "radius": 0.136,
          "controllerType": 2,
          "collisionMaskBit": 2
        },
        {
          "localPosition": [
            0.06,
            -0.025,
            -0.035
          ],
          "radius": 0.136,
          "controllerType": 2,
          "collisionMaskBit": 2
        },
        {
          "localPosition": [
            0.07,
            0.01,
            0.045
          ],
          "radius": 0.138,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.07,
            0.01,
            -0.045
          ],
          "radius": 0.138,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.165,
            0.005,
            -0.04
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.27,
            -0.015,
            -0.025
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.06,
            -0.03,
            -0.025
          ],
          "radius": 0.181,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.32,
            -0.03,
            -0.03
          ],
          "radius": 0.187,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.165,
            0.005,
            0.04
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.27,
            -0.015,
            0.025
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.06,
            -0.03,
            0.025
          ],
          "radius": 0.181,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.32,
            -0.03,
            0.03
          ],
          "radius": 0.187,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2837f2": {
      "sourceAddress": "0x0c2837f2",
      "sourceSha256": "6a2a47e5c9a2a74271429cd2b889f4dc5bf12e384c4be062396ed92cf7aa55f5",
      "records": [
        {
          "localPosition": [
            -0.01,
            0.015,
            -0.05
          ],
          "radius": 0.154,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.068,
            0.01,
            -0.055
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.18,
            0.0,
            -0.055
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.28,
            0.0,
            -0.05
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.015,
            0.0,
            -0.03
          ],
          "radius": 0.19,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.01,
            0.015,
            0.05
          ],
          "radius": 0.154,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.068,
            0.01,
            0.055
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.18,
            0.0,
            0.055
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.28,
            0.0,
            0.05
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.015,
            0.0,
            0.03
          ],
          "radius": 0.19,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283860": {
      "sourceAddress": "0x0c283860",
      "sourceSha256": "129c632fdcf5875ac8b3de836622132ebbeb35b3efe98d7fd7689950a6024ab6",
      "records": [
        {
          "localPosition": [
            -0.02,
            0.015,
            -0.05
          ],
          "radius": 0.136,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.043,
            0.01,
            -0.03
          ],
          "radius": 0.151,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.14,
            0.0,
            -0.02
          ],
          "radius": 0.153,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            0.0,
            -0.005
          ],
          "radius": 0.157,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.02,
            -0.015,
            -0.01
          ],
          "radius": 0.17,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.085,
            -0.03,
            -0.015
          ],
          "radius": 0.168,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.255,
            -0.025,
            -0.02
          ],
          "radius": 0.17,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.02,
            0.015,
            0.05
          ],
          "radius": 0.136,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.043,
            0.01,
            0.03
          ],
          "radius": 0.151,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.14,
            0.0,
            0.02
          ],
          "radius": 0.153,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            0.0,
            0.005
          ],
          "radius": 0.157,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.02,
            -0.015,
            0.01
          ],
          "radius": 0.17,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.085,
            -0.03,
            0.015
          ],
          "radius": 0.168,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.255,
            -0.025,
            0.02
          ],
          "radius": 0.17,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2838f6": {
      "sourceAddress": "0x0c2838f6",
      "sourceSha256": "fc6086278ac5815ef44424e26ce6695b56cb0fa4a0213dd6f904e84c71312195",
      "records": [
        {
          "localPosition": [
            0.015,
            0.01,
            -0.04
          ],
          "radius": 0.153,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.113,
            -0.02,
            -0.03
          ],
          "radius": 0.174,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            0.01,
            -0.045
          ],
          "radius": 0.19,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.295,
            0.01,
            -0.04
          ],
          "radius": 0.184,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            0.0,
            -0.03
          ],
          "radius": 0.19,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.015,
            0.01,
            0.04
          ],
          "radius": 0.153,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.113,
            -0.02,
            0.03
          ],
          "radius": 0.174,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            0.01,
            0.045
          ],
          "radius": 0.19,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.295,
            0.01,
            0.04
          ],
          "radius": 0.184,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.03,
            0.0,
            0.03
          ],
          "radius": 0.19,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283964": {
      "sourceAddress": "0x0c283964",
      "sourceSha256": "1e1ab0314210fe6b6ed5779b80046ae3b9c3d987b2dfe5650256648228e37ae0",
      "records": [
        {
          "localPosition": [
            0.03,
            0.01,
            -0.035
          ],
          "radius": 0.196,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            -0.005,
            -0.025
          ],
          "radius": 0.175,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.31,
            0.025,
            -0.025
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            0.01,
            0.035
          ],
          "radius": 0.196,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            -0.005,
            0.025
          ],
          "radius": 0.175,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.31,
            0.025,
            0.025
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2839aa": {
      "sourceAddress": "0x0c2839aa",
      "sourceSha256": "2512ffdd9e9097f571757b233e28fddad88eabb99a4f6d37f2dede2c371a3d22",
      "records": [
        {
          "localPosition": [
            0.08,
            0.0,
            0.045
          ],
          "radius": 0.139,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.08,
            0.0,
            -0.045
          ],
          "radius": 0.139,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.01,
            0.005,
            -0.03
          ],
          "radius": 0.176,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            -0.005,
            -0.045
          ],
          "radius": 0.201,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.265,
            -0.01,
            -0.03
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.01,
            0.005,
            0.03
          ],
          "radius": 0.176,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            -0.005,
            0.045
          ],
          "radius": 0.201,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.265,
            -0.01,
            0.03
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283a04": {
      "sourceAddress": "0x0c283a04",
      "sourceSha256": "0be3811b0fd9d3c012493fc1b87832221b74a91a796bb327cb0b399461cfa4e5",
      "records": [
        {
          "localPosition": [
            0.005,
            0.005,
            -0.04
          ],
          "radius": 0.155,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            0.01,
            -0.045
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.015,
            -0.035
          ],
          "radius": 0.191,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.315,
            0.0,
            -0.035
          ],
          "radius": 0.215,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.065,
            0.01,
            -0.02
          ],
          "radius": 0.237,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.175,
            0.0,
            -0.015
          ],
          "radius": 0.212,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.01
          ],
          "radius": 0.235,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.218,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.005,
            0.005,
            0.04
          ],
          "radius": 0.155,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            0.01,
            0.045
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.015,
            0.035
          ],
          "radius": 0.191,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.315,
            0.0,
            0.035
          ],
          "radius": 0.215,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.065,
            0.01,
            0.02
          ],
          "radius": 0.237,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.175,
            0.0,
            0.015
          ],
          "radius": 0.212,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.01
          ],
          "radius": 0.235,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.218,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283aae": {
      "sourceAddress": "0x0c283aae",
      "sourceSha256": "03803bd34fd357cde8a0b3e57da4e799678cf0ef4b6c5b2e17a3f3525d599962",
      "records": [
        {
          "localPosition": [
            0.045,
            -0.005,
            -0.03
          ],
          "radius": 0.167,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.16,
            -0.02,
            -0.04
          ],
          "radius": 0.173,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.305,
            -0.025,
            -0.035
          ],
          "radius": 0.178,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.06,
            -0.03,
            -0.03
          ],
          "radius": 0.198,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.155,
            -0.02,
            -0.03
          ],
          "radius": 0.18,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            -0.005,
            -0.05
          ],
          "radius": 0.214,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.045,
            -0.005,
            0.03
          ],
          "radius": 0.167,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.16,
            -0.02,
            0.04
          ],
          "radius": 0.173,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.305,
            -0.025,
            0.035
          ],
          "radius": 0.178,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.06,
            -0.03,
            0.03
          ],
          "radius": 0.198,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.155,
            -0.02,
            0.03
          ],
          "radius": 0.18,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            -0.005,
            0.05
          ],
          "radius": 0.214,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283b30": {
      "sourceAddress": "0x0c283b30",
      "sourceSha256": "fc6e1e24dad44c535400969a81eb595ade50d2d019540f6a5f3fdc74f98b5b91",
      "records": [
        {
          "localPosition": [
            0.05,
            0.01,
            0.12
          ],
          "radius": 0.152,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.05,
            0.01,
            -0.12
          ],
          "radius": 0.152,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.055,
            0.015,
            0.035
          ],
          "radius": 0.158,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.005,
            -0.01,
            0.0
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.155,
            -0.03,
            0.01
          ],
          "radius": 0.193,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.055,
            0.015,
            -0.035
          ],
          "radius": 0.158,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.005,
            -0.01,
            0.0
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.155,
            -0.03,
            -0.01
          ],
          "radius": 0.193,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283b8a": {
      "sourceAddress": "0x0c283b8a",
      "sourceSha256": "f8ebced36e62156c55d4c6b095e975b0fc71178886cb46e4aca45e413c68b504",
      "records": [
        {
          "localPosition": [
            0.065,
            0.015,
            -0.025
          ],
          "radius": 0.138,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.065,
            0.015,
            0.025
          ],
          "radius": 0.138,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.005,
            -0.015,
            -0.035
          ],
          "radius": 0.159,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.145,
            0.0,
            -0.04
          ],
          "radius": 0.174,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.315,
            -0.015,
            -0.035
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.07,
            -0.015,
            -0.015
          ],
          "radius": 0.179,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.21,
            -0.015,
            -0.02
          ],
          "radius": 0.183,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.39,
            -0.02,
            0.0
          ],
          "radius": 0.191,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.005,
            -0.015,
            0.035
          ],
          "radius": 0.159,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.145,
            0.0,
            0.04
          ],
          "radius": 0.174,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.315,
            -0.015,
            0.035
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.07,
            -0.015,
            0.015
          ],
          "radius": 0.179,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.21,
            -0.015,
            0.02
          ],
          "radius": 0.183,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.39,
            -0.02,
            0.0
          ],
          "radius": 0.191,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283c20": {
      "sourceAddress": "0x0c283c20",
      "sourceSha256": "58894c5aa02557c81b48387a38f79ff3855670c143b788b78ba3dc7d6b4b2588",
      "records": [
        {
          "localPosition": [
            0.135,
            -0.01,
            0.045
          ],
          "radius": 0.152,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.135,
            -0.01,
            -0.045
          ],
          "radius": 0.152,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.055,
            -0.01,
            -0.025
          ],
          "radius": 0.147,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.135,
            -0.06,
            -0.02
          ],
          "radius": 0.125,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            -0.01,
            0.025
          ],
          "radius": 0.147,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.135,
            -0.06,
            0.02
          ],
          "radius": 0.125,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283c66": {
      "sourceAddress": "0x0c283c66",
      "sourceSha256": "2becd055f49ded5b9a1ed0332aed8bc9b0d756e63306a40d9a794e06945597d3",
      "records": [
        {
          "localPosition": [
            0.035,
            0.015,
            -0.02
          ],
          "radius": 0.175,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            0.0,
            -0.025
          ],
          "radius": 0.184,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.035
          ],
          "radius": 0.18,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.035,
            0.015,
            0.02
          ],
          "radius": 0.175,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.175,
            0.0,
            0.025
          ],
          "radius": 0.184,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.035
          ],
          "radius": 0.18,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283cac": {
      "sourceAddress": "0x0c283cac",
      "sourceSha256": "7b2a7499979c9c8203b05432f9adb6e01aa334693cd647626f3041eca540772b",
      "records": [
        {
          "localPosition": [
            0.12,
            0.0,
            -0.075
          ],
          "radius": 0.189,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.12,
            0.0,
            0.075
          ],
          "radius": 0.189,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.015,
            -0.025,
            0.0
          ],
          "radius": 0.191,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            0.005,
            -0.02
          ],
          "radius": 0.222,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            0.0,
            -0.07
          ],
          "radius": 0.226,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            -0.025,
            0.0
          ],
          "radius": 0.191,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.075,
            0.005,
            0.02
          ],
          "radius": 0.222,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            0.0,
            0.07
          ],
          "radius": 0.226,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283d06": {
      "sourceAddress": "0x0c283d06",
      "sourceSha256": "ef0a914bd1722c638a8cec0bec77c7891a77a8e8cc83e6d3f639b63744a1a79d",
      "records": [
        {
          "localPosition": [
            0.02,
            0.0,
            0.0
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            -0.02
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.25,
            0.0,
            -0.01
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.02,
            0.0,
            0.0
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            0.02
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.25,
            0.0,
            0.01
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c283d4c": {
      "sourceAddress": "0x0c283d4c",
      "sourceSha256": "7b2ac1cda9a7eeed0a0b957a8ac17b18a0218fc5b1335ba756ea5b28d605ca4f",
      "records": [
        {
          "localPosition": [
            0.085,
            -0.01,
            -0.045
          ],
          "radius": 0.186,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.085,
            -0.01,
            0.045
          ],
          "radius": 0.186,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.015,
            -0.02,
            -0.035
          ],
          "radius": 0.193,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.115,
            -0.005,
            -0.035
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.235,
            -0.005,
            -0.02
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.02,
            0.0
          ],
          "radius": 0.181,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.015,
            -0.02,
            0.035
          ],
          "radius": 0.193,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.115,
            -0.005,
            0.035
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.235,
            -0.005,
            0.02
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.02,
            0.0
          ],
          "radius": 0.181,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283dba": {
      "sourceAddress": "0x0c283dba",
      "sourceSha256": "c027db18df17894783d3452c6923fed6b6f0b1842ca3541c55df5158b066bc5a",
      "records": [
        {
          "localPosition": [
            0.145,
            0.0,
            -0.075
          ],
          "radius": 0.192,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.145,
            0.0,
            0.075
          ],
          "radius": 0.192,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.1,
            0.025,
            0.005
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.025,
            0.0
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.03,
            0.0
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.035,
            0.0,
            -0.005
          ],
          "radius": 0.177,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.1,
            0.025,
            -0.005
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.025,
            0.0
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.03,
            0.0
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.035,
            0.0,
            0.005
          ],
          "radius": 0.177,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283e28": {
      "sourceAddress": "0x0c283e28",
      "sourceSha256": "6885ffb9298cf3ff6329a7deea9fe88cb505fefd80ee0681838e6d2671dd8145",
      "records": [
        {
          "localPosition": [
            0.105,
            0.005,
            0.05
          ],
          "radius": 0.184,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.105,
            -0.005,
            -0.05
          ],
          "radius": 0.194,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.005,
            -0.01,
            -0.01
          ],
          "radius": 0.177,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.065,
            -0.025,
            0.01
          ],
          "radius": 0.152,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.165,
            0.0,
            -0.025
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.24,
            0.0,
            -0.035
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            0.0,
            -0.03
          ],
          "radius": 0.16,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.005,
            -0.01,
            0.01
          ],
          "radius": 0.177,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.065,
            -0.025,
            -0.01
          ],
          "radius": 0.152,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.165,
            0.0,
            0.025
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.24,
            0.0,
            0.035
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.015,
            0.0,
            0.03
          ],
          "radius": 0.16,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283eaa": {
      "sourceAddress": "0x0c283eaa",
      "sourceSha256": "87a4e84fb7e4eb4a43c49ef8908b655f49f82f26258a83e94ec6fdf5b43db385",
      "records": [
        {
          "localPosition": [
            -0.02,
            0.02,
            -0.025
          ],
          "radius": 0.129,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            0.015,
            -0.025
          ],
          "radius": 0.136,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.155,
            0.015,
            -0.015
          ],
          "radius": 0.119,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            0.0
          ],
          "radius": 0.107,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            -0.015,
            0.0
          ],
          "radius": 0.115,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.02,
            0.02,
            0.025
          ],
          "radius": 0.129,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.055,
            0.015,
            0.025
          ],
          "radius": 0.136,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.155,
            0.015,
            0.015
          ],
          "radius": 0.119,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            -0.005,
            0.0
          ],
          "radius": 0.107,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.045,
            -0.015,
            0.0
          ],
          "radius": 0.115,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283f18": {
      "sourceAddress": "0x0c283f18",
      "sourceSha256": "02c267b92e97f996e5c5ccd9089c3cfb7a907456b58c9a304fb3a9258912c040",
      "records": [
        {
          "localPosition": [
            0.095,
            -0.01,
            -0.07
          ],
          "radius": 0.246,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.26,
            0.0,
            -0.04
          ],
          "radius": 0.238,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            -0.025
          ],
          "radius": 0.229,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.24,
            0.0,
            -0.055
          ],
          "radius": 0.224,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.095,
            -0.01,
            0.07
          ],
          "radius": 0.246,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.26,
            0.0,
            0.04
          ],
          "radius": 0.238,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.025
          ],
          "radius": 0.229,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.24,
            0.0,
            0.055
          ],
          "radius": 0.224,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283f72": {
      "sourceAddress": "0x0c283f72",
      "sourceSha256": "d2c3cacd7c3a0059a1853d3d4ff52022737ff5a1a1df247a320427dcd033e395",
      "records": [
        {
          "localPosition": [
            0.195,
            0.02,
            -0.075
          ],
          "radius": 0.164,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.195,
            0.02,
            0.075
          ],
          "radius": 0.164,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.12,
            0.015,
            -0.045
          ],
          "radius": 0.191,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            0.015,
            -0.025
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.005,
            -0.025
          ],
          "radius": 0.168,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.12,
            0.015,
            0.045
          ],
          "radius": 0.191,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            0.015,
            0.025
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.005,
            0.025
          ],
          "radius": 0.168,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c283fcc": {
      "sourceAddress": "0x0c283fcc",
      "sourceSha256": "13b99e32b58988847d720473f6b57a1df60578e66c053ef8e8b0d1cac81a7917",
      "records": [
        {
          "localPosition": [
            -0.03,
            -0.02,
            -0.03
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            -0.02
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.01
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.02
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            -0.02,
            0.03
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            0.02
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.01
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.02
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28404e": {
      "sourceAddress": "0x0c28404e",
      "sourceSha256": "9b0cf88c9f26c6b4ac38e6d3e857338f27ea6ea255223aa1e36e1ce33f7da7f4",
      "records": [
        {
          "localPosition": [
            -0.005,
            0.0,
            -0.03
          ],
          "radius": 0.193,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.005,
            0.0,
            0.03
          ],
          "radius": 0.193,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.13,
            0.005,
            -0.03
          ],
          "radius": 0.216,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.13,
            0.005,
            0.03
          ],
          "radius": 0.216,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.1,
            -0.005,
            -0.005
          ],
          "radius": 0.2,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.01
          ],
          "radius": 0.198,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            -0.03,
            0.0
          ],
          "radius": 0.202,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.1,
            -0.005,
            0.005
          ],
          "radius": 0.2,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.01
          ],
          "radius": 0.198,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.075,
            -0.03,
            0.0
          ],
          "radius": 0.202,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2840bc": {
      "sourceAddress": "0x0c2840bc",
      "sourceSha256": "cc23c2a9b49da7d876ef4146b0840d5c5a37b12bd4132c778d8ded2beb0b43cf",
      "records": [
        {
          "localPosition": [
            0.195,
            0.025,
            -0.06
          ],
          "radius": 0.226,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.195,
            0.025,
            0.055
          ],
          "radius": 0.226,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.13,
            -0.005,
            -0.03
          ],
          "radius": 0.208,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.33,
            0.0,
            -0.025
          ],
          "radius": 0.209,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.17,
            -0.015,
            -0.02
          ],
          "radius": 0.217,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.13,
            -0.005,
            0.03
          ],
          "radius": 0.208,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.33,
            0.0,
            0.025
          ],
          "radius": 0.209,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.17,
            -0.015,
            0.02
          ],
          "radius": 0.217,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284116": {
      "sourceAddress": "0x0c284116",
      "sourceSha256": "612c720ce16510b19973bce83d89d5896fd25bb48c6741616a09363a183bb73b",
      "records": [
        {
          "localPosition": [
            0.015,
            0.0,
            -0.03
          ],
          "radius": 0.166,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            0.015,
            -0.035
          ],
          "radius": 0.16,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.015,
            -0.025
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.03
          ],
          "radius": 0.177,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            -0.025
          ],
          "radius": 0.167,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.152,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.015,
            0.0,
            0.03
          ],
          "radius": 0.166,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            0.015,
            0.035
          ],
          "radius": 0.16,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.015,
            0.025
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.03
          ],
          "radius": 0.177,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.025
          ],
          "radius": 0.167,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.152,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2841c0": {
      "sourceAddress": "0x0c2841c0",
      "sourceSha256": "19680479aa4bbe2edd1f3ec9eed1f64003d36dc9d19494258f10c90a18d8b886",
      "records": [
        {
          "localPosition": [
            0.17,
            0.015,
            0.055
          ],
          "radius": 0.138,
          "controllerType": 2,
          "collisionMaskBit": 2
        },
        {
          "localPosition": [
            0.17,
            0.015,
            -0.055
          ],
          "radius": 0.138,
          "controllerType": 2,
          "collisionMaskBit": 2
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.065
          ],
          "radius": 0.138,
          "controllerType": 47,
          "collisionMaskBit": 4
        },
        {
          "localPosition": [
            0.025,
            0.005,
            -0.055
          ],
          "radius": 0.142,
          "controllerType": 15,
          "collisionMaskBit": 8
        },
        {
          "localPosition": [
            0.13,
            0.015,
            -0.015
          ],
          "radius": 0.133,
          "controllerType": 15,
          "collisionMaskBit": 8
        },
        {
          "localPosition": [
            0.025,
            0.005,
            0.055
          ],
          "radius": 0.142,
          "controllerType": 9,
          "collisionMaskBit": 64
        },
        {
          "localPosition": [
            0.13,
            0.015,
            0.015
          ],
          "radius": 0.133,
          "controllerType": 9,
          "collisionMaskBit": 64
        },
        {
          "localPosition": [
            0.045,
            -0.01,
            -0.05
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.02,
            -0.06
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.33,
            0.005,
            -0.045
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            0.0,
            -0.06
          ],
          "radius": 0.229,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.225,
            0.01,
            -0.05
          ],
          "radius": 0.232,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.39,
            -0.005,
            -0.035
          ],
          "radius": 0.234,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.045,
            -0.01,
            0.05
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.02,
            0.06
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.33,
            0.005,
            0.045
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            0.0,
            0.06
          ],
          "radius": 0.229,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.225,
            0.01,
            0.05
          ],
          "radius": 0.232,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.39,
            -0.005,
            0.035
          ],
          "radius": 0.234,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284288": {
      "sourceAddress": "0x0c284288",
      "sourceSha256": "11653c35044343145817705dbebdfaae03266538e95b68af623e719520d5d9b4",
      "records": [
        {
          "localPosition": [
            0.195,
            0.0,
            -0.085
          ],
          "radius": 0.255,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.195,
            0.0,
            0.085
          ],
          "radius": 0.255,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.165,
            -0.005,
            -0.02
          ],
          "radius": 0.267,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.305,
            -0.035,
            -0.065
          ],
          "radius": 0.245,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.07,
            0.005,
            -0.065
          ],
          "radius": 0.24,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.165,
            -0.005,
            0.02
          ],
          "radius": 0.267,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.305,
            -0.035,
            0.065
          ],
          "radius": 0.245,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.07,
            0.005,
            0.065
          ],
          "radius": 0.24,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2842e2": {
      "sourceAddress": "0x0c2842e2",
      "sourceSha256": "af384d6e5118556aef2ffdafc6e38b1483bb6c1ed68c5ad7aabfc3f8a4384191",
      "records": [
        {
          "localPosition": [
            0.16,
            0.02,
            -0.04
          ],
          "radius": 0.214,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.16,
            0.02,
            0.04
          ],
          "radius": 0.214,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.12,
            0.01,
            -0.05
          ],
          "radius": 0.216,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.235,
            0.015,
            -0.055
          ],
          "radius": 0.208,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.35,
            0.0,
            -0.035
          ],
          "radius": 0.206,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.115,
            0.0,
            -0.025
          ],
          "radius": 0.213,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.12,
            0.01,
            0.05
          ],
          "radius": 0.216,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.235,
            0.015,
            0.055
          ],
          "radius": 0.208,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.35,
            0.0,
            0.035
          ],
          "radius": 0.206,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.115,
            0.0,
            0.025
          ],
          "radius": 0.213,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284350": {
      "sourceAddress": "0x0c284350",
      "sourceSha256": "2af9f8c8dc023b3c02a56fd8158201ad5524ee8c22eb9c973a39210e5de3234d",
      "records": [
        {
          "localPosition": [
            0.015,
            -0.005,
            -0.03
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            -0.005,
            -0.02
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.315,
            -0.015,
            -0.01
          ],
          "radius": 0.175,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.025,
            0.0
          ],
          "radius": 0.18,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.188,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.015,
            -0.005,
            0.03
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            -0.005,
            0.02
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.315,
            -0.015,
            0.01
          ],
          "radius": 0.175,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.025,
            0.0
          ],
          "radius": 0.18,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.188,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2843be": {
      "sourceAddress": "0x0c2843be",
      "sourceSha256": "3d1f11babfbd8cc769e12897841c51507bc2162b5f8b035063c130b2f56da161",
      "records": [
        {
          "localPosition": [
            0.005,
            0.035,
            0.0
          ],
          "radius": 0.159,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            0.02,
            -0.025
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.27,
            0.035,
            -0.01
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.01,
            -0.015
          ],
          "radius": 0.19,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            -0.01
          ],
          "radius": 0.2,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.005,
            0.035,
            0.0
          ],
          "radius": 0.159,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            0.02,
            0.025
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.27,
            0.035,
            0.01
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.01,
            0.015
          ],
          "radius": 0.19,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.01
          ],
          "radius": 0.2,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28442c": {
      "sourceAddress": "0x0c28442c",
      "sourceSha256": "5cca0b07020b4586c417d5908f5e28ff6522601b26f0b034f5d365e28ee538a9",
      "records": [
        {
          "localPosition": [
            0.085,
            0.04,
            -0.055
          ],
          "radius": 0.147,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.215,
            0.0,
            -0.045
          ],
          "radius": 0.166,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.335,
            -0.035,
            -0.085
          ],
          "radius": 0.206,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.085,
            0.02,
            -0.055
          ],
          "radius": 0.195,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.23,
            -0.02,
            -0.035
          ],
          "radius": 0.133,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.085,
            0.04,
            0.055
          ],
          "radius": 0.147,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.215,
            0.0,
            0.045
          ],
          "radius": 0.166,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.335,
            -0.035,
            0.07
          ],
          "radius": 0.197,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.085,
            0.02,
            0.055
          ],
          "radius": 0.195,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.23,
            -0.02,
            0.035
          ],
          "radius": 0.133,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28449a": {
      "sourceAddress": "0x0c28449a",
      "sourceSha256": "a0744251e03e998b2ba6bc5f5dba4e15aa182b932ea7a20121c5188ce8c2d56e",
      "records": [
        {
          "localPosition": [
            -0.03,
            -0.025,
            -0.06
          ],
          "radius": 0.183,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.13,
            -0.005,
            0.005
          ],
          "radius": 0.155,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.28,
            -0.02,
            -0.025
          ],
          "radius": 0.176,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.085,
            -0.03,
            -0.025
          ],
          "radius": 0.182,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.28,
            -0.04,
            -0.025
          ],
          "radius": 0.201,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            -0.025,
            0.06
          ],
          "radius": 0.183,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.13,
            -0.005,
            -0.005
          ],
          "radius": 0.155,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.28,
            -0.02,
            0.025
          ],
          "radius": 0.176,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.085,
            -0.03,
            0.025
          ],
          "radius": 0.182,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.28,
            -0.04,
            0.025
          ],
          "radius": 0.201,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284508": {
      "sourceAddress": "0x0c284508",
      "sourceSha256": "76b5dc5e5f0768e2a87f16e26592e700affdd59cd765b787685d6925da4376b2",
      "records": [
        {
          "localPosition": [
            0.035,
            0.005,
            -0.04
          ],
          "radius": 0.191,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            0.005,
            -0.035
          ],
          "radius": 0.188,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            0.01,
            -0.025
          ],
          "radius": 0.194,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.025,
            0.005,
            -0.02
          ],
          "radius": 0.207,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.015
          ],
          "radius": 0.216,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.395,
            0.0,
            -0.015
          ],
          "radius": 0.216,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.035,
            0.005,
            0.04
          ],
          "radius": 0.191,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            0.005,
            0.035
          ],
          "radius": 0.188,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            0.01,
            0.025
          ],
          "radius": 0.194,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.025,
            0.005,
            0.02
          ],
          "radius": 0.207,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.015
          ],
          "radius": 0.216,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.395,
            0.0,
            0.015
          ],
          "radius": 0.216,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28458a": {
      "sourceAddress": "0x0c28458a",
      "sourceSha256": "5423af677fe8528b3dc546e785519036b6fed9089bd497298d50a21795765119",
      "records": [
        {
          "localPosition": [
            -0.03,
            -0.02,
            -0.03
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            -0.02
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            0.0,
            -0.01
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.02
          ],
          "radius": 0.15,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.152,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.03,
            -0.02,
            0.03
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            -0.01,
            0.02
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            0.0,
            0.01
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.02
          ],
          "radius": 0.15,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.0
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.152,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284634": {
      "sourceAddress": "0x0c284634",
      "sourceSha256": "d9b5e0560bd9b49f0753861e2c51eb8d69afe53cd98caa698b9412fa199d4d81",
      "records": [
        {
          "localPosition": [
            0.125,
            -0.005,
            0.075
          ],
          "radius": 0.158,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.125,
            -0.005,
            -0.075
          ],
          "radius": 0.158,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.02,
            -0.02,
            -0.03
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.025,
            -0.035,
            -0.02
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            -0.03,
            -0.02
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.18,
            0.0,
            -0.03
          ],
          "radius": 0.157,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.02,
            -0.02,
            0.03
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.025,
            -0.035,
            0.02
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.075,
            -0.03,
            0.02
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.18,
            0.0,
            0.03
          ],
          "radius": 0.157,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2846a2": {
      "sourceAddress": "0x0c2846a2",
      "sourceSha256": "f70ecf46c27754130db14c0e9f2b14af1ebd68b95e02812291c8c5c1e06a9d69",
      "records": [
        {
          "localPosition": [
            0.155,
            0.005,
            0.04
          ],
          "radius": 0.173,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.005,
            -0.04
          ],
          "radius": 0.173,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.07,
            0.015,
            -0.06
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.165,
            0.02,
            -0.075
          ],
          "radius": 0.2,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.07,
            0.015,
            0.06
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.165,
            0.02,
            0.075
          ],
          "radius": 0.2,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2846e8": {
      "sourceAddress": "0x0c2846e8",
      "sourceSha256": "b20e2cdbe12e7e306dcb62854ba5caa3eacb7f34e0e2a6a2e7231de72fb5408c",
      "records": [
        {
          "localPosition": [
            0.04,
            0.015,
            -0.045
          ],
          "radius": 0.145,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.145,
            -0.015,
            -0.055
          ],
          "radius": 0.171,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.25,
            -0.01,
            -0.04
          ],
          "radius": 0.17,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.02,
            -0.015
          ],
          "radius": 0.173,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.125,
            -0.025,
            -0.025
          ],
          "radius": 0.201,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            -0.02,
            0.015
          ],
          "radius": 0.18,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.186,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.04,
            0.015,
            0.045
          ],
          "radius": 0.145,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.145,
            -0.015,
            0.055
          ],
          "radius": 0.171,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.25,
            -0.01,
            0.04
          ],
          "radius": 0.17,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.02,
            0.015
          ],
          "radius": 0.173,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.125,
            -0.025,
            0.025
          ],
          "radius": 0.201,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            -0.02,
            -0.015
          ],
          "radius": 0.18,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.43,
            0.01,
            0.0
          ],
          "radius": 0.186,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28477e": {
      "sourceAddress": "0x0c28477e",
      "sourceSha256": "a74bcf6218b5ac29d69d43cabbf9c69f4e67d07e8fe07c60129e6bf9835659a6",
      "records": [
        {
          "localPosition": [
            0.07,
            0.005,
            -0.035
          ],
          "radius": 0.2,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            -0.005,
            -0.045
          ],
          "radius": 0.202,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.28,
            -0.015,
            -0.025
          ],
          "radius": 0.211,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.335,
            -0.015,
            -0.025
          ],
          "radius": 0.212,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.06,
            -0.025,
            -0.02
          ],
          "radius": 0.233,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.19,
            -0.01,
            -0.03
          ],
          "radius": 0.232,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.35,
            0.0,
            -0.02
          ],
          "radius": 0.235,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.5,
            0.01,
            0.0
          ],
          "radius": 0.224,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.07,
            0.005,
            0.035
          ],
          "radius": 0.2,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.175,
            -0.005,
            0.045
          ],
          "radius": 0.202,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.28,
            -0.015,
            0.025
          ],
          "radius": 0.211,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.335,
            -0.015,
            0.025
          ],
          "radius": 0.212,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.06,
            -0.025,
            0.02
          ],
          "radius": 0.233,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.19,
            -0.01,
            0.03
          ],
          "radius": 0.232,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.35,
            0.0,
            0.02
          ],
          "radius": 0.235,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.5,
            0.01,
            0.0
          ],
          "radius": 0.224,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284828": {
      "sourceAddress": "0x0c284828",
      "sourceSha256": "ad6e9b71e6e95643aa5e661ff4837af668f5edb9563d63efdedf63db25cdbc1b",
      "records": [
        {
          "localPosition": [
            0.11,
            0.01,
            -0.04
          ],
          "radius": 0.139,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.11,
            0.01,
            0.04
          ],
          "radius": 0.139,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.05,
            0.015,
            -0.025
          ],
          "radius": 0.159,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.14,
            0.01,
            0.005
          ],
          "radius": 0.154,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            0.045,
            0.03
          ],
          "radius": 0.141,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.05,
            0.015,
            0.025
          ],
          "radius": 0.159,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.14,
            0.01,
            -0.005
          ],
          "radius": 0.154,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.03,
            0.045,
            -0.03
          ],
          "radius": 0.141,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284882": {
      "sourceAddress": "0x0c284882",
      "sourceSha256": "e793e55495b924db3dc8261545e156ec230f24adc7a91d72bdfea5e5c6be3644",
      "records": [
        {
          "localPosition": [
            0.04,
            0.005,
            -0.04
          ],
          "radius": 0.151,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.078,
            0.005,
            -0.06
          ],
          "radius": 0.163,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.2,
            -0.015,
            -0.05
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.005,
            -0.03,
            -0.04
          ],
          "radius": 0.163,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.04,
            0.005,
            0.04
          ],
          "radius": 0.151,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.078,
            0.005,
            0.06
          ],
          "radius": 0.163,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.2,
            -0.015,
            0.05
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.005,
            -0.03,
            0.04
          ],
          "radius": 0.163,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2848dc": {
      "sourceAddress": "0x0c2848dc",
      "sourceSha256": "ba53336f6665f24841bd63c03d8119f016933991db41b6c7098fda5c8b7a9857",
      "records": [
        {
          "localPosition": [
            -0.06,
            0.015,
            -0.085
          ],
          "radius": 0.185,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            -0.07
          ],
          "radius": 0.19,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.108,
            -0.015,
            -0.055
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.225,
            -0.025,
            -0.025
          ],
          "radius": 0.199,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.06,
            0.015,
            0.085
          ],
          "radius": 0.185,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.07
          ],
          "radius": 0.19,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.108,
            -0.015,
            0.055
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.225,
            -0.025,
            0.025
          ],
          "radius": 0.199,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284936": {
      "sourceAddress": "0x0c284936",
      "sourceSha256": "ecaeb10ae237e13d3e966e3db0011384ea147c579f0719561049d5ca7974ffe2",
      "records": [
        {
          "localPosition": [
            -0.02,
            -0.005,
            -0.035
          ],
          "radius": 0.206,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.125,
            0.0,
            -0.02
          ],
          "radius": 0.199,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            -0.015,
            -0.02
          ],
          "radius": 0.204,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.03,
            -0.025,
            -0.015
          ],
          "radius": 0.209,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.15,
            0.0,
            -0.01
          ],
          "radius": 0.195,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.365,
            0.03,
            0.0
          ],
          "radius": 0.199,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.02,
            -0.005,
            0.035
          ],
          "radius": 0.206,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.125,
            0.0,
            0.02
          ],
          "radius": 0.199,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            -0.015,
            0.02
          ],
          "radius": 0.204,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.03,
            -0.025,
            0.015
          ],
          "radius": 0.209,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.15,
            0.0,
            0.01
          ],
          "radius": 0.195,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.365,
            0.03,
            0.0
          ],
          "radius": 0.199,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c2849b8": {
      "sourceAddress": "0x0c2849b8",
      "sourceSha256": "52f64e0a53f860e902dabf2b040035604c7a53e1b1483cf3d4c814c7b47be6b4",
      "records": [
        {
          "localPosition": [
            0.02,
            -0.025,
            -0.025
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.17,
            -0.025,
            -0.01
          ],
          "radius": 0.175,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            -0.015,
            0.005
          ],
          "radius": 0.187,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.105,
            -0.02,
            0.0
          ],
          "radius": 0.198,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.28,
            -0.015,
            0.0
          ],
          "radius": 0.22,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.405,
            -0.005,
            0.0
          ],
          "radius": 0.221,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.02,
            -0.025,
            0.025
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.17,
            -0.025,
            0.01
          ],
          "radius": 0.175,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            -0.015,
            -0.005
          ],
          "radius": 0.187,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.105,
            -0.02,
            0.0
          ],
          "radius": 0.198,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.28,
            -0.015,
            0.0
          ],
          "radius": 0.22,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.405,
            -0.005,
            0.0
          ],
          "radius": 0.221,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284a3a": {
      "sourceAddress": "0x0c284a3a",
      "sourceSha256": "04c28ec32ddcf1f2eb86e670ffa56a267f5ed942343c6715187e6e642f5bd8f4",
      "records": [
        {
          "localPosition": [
            0.155,
            0.02,
            -0.015
          ],
          "radius": 0.154,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.02,
            0.015
          ],
          "radius": 0.154,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.08,
            0.01,
            -0.03
          ],
          "radius": 0.138,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.165,
            0.01,
            -0.01
          ],
          "radius": 0.133,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.04,
            -0.015,
            0.005
          ],
          "radius": 0.13,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.165,
            -0.02,
            -0.01
          ],
          "radius": 0.136,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.27,
            -0.02,
            -0.01
          ],
          "radius": 0.15,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.08,
            0.01,
            0.03
          ],
          "radius": 0.138,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.165,
            0.01,
            0.01
          ],
          "radius": 0.133,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.04,
            -0.015,
            -0.005
          ],
          "radius": 0.13,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.165,
            -0.02,
            0.01
          ],
          "radius": 0.136,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.27,
            -0.02,
            0.01
          ],
          "radius": 0.15,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284abc": {
      "sourceAddress": "0x0c284abc",
      "sourceSha256": "cbbfa06fb0139fa50912baed110499e19c23b69dbc301a1996e53a19ed72d4c8",
      "records": [
        {
          "localPosition": [
            0.175,
            -0.02,
            -0.035
          ],
          "radius": 0.159,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.175,
            -0.02,
            0.035
          ],
          "radius": 0.159,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.17,
            0.03,
            -0.05
          ],
          "radius": 0.161,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.275,
            -0.015,
            -0.05
          ],
          "radius": 0.176,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.055,
            -0.005,
            -0.035
          ],
          "radius": 0.164,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.17,
            0.03,
            0.05
          ],
          "radius": 0.161,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.275,
            -0.015,
            0.05
          ],
          "radius": 0.176,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.055,
            -0.005,
            0.035
          ],
          "radius": 0.164,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284b16": {
      "sourceAddress": "0x0c284b16",
      "sourceSha256": "e0eef1ea4db161cfd76b52933d1bda0637fb56af6e845fb1cf39912762e0c44a",
      "records": [
        {
          "localPosition": [
            0.025,
            0.01,
            -0.08
          ],
          "radius": 0.167,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            0.015,
            -0.055
          ],
          "radius": 0.183,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.28,
            0.005,
            -0.06
          ],
          "radius": 0.198,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.025,
            0.0,
            -0.04
          ],
          "radius": 0.205,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.17,
            0.0,
            -0.025
          ],
          "radius": 0.216,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.43,
            0.0,
            -0.03
          ],
          "radius": 0.206,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.025,
            0.01,
            0.08
          ],
          "radius": 0.167,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.175,
            0.015,
            0.055
          ],
          "radius": 0.183,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.28,
            0.005,
            0.06
          ],
          "radius": 0.198,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.025,
            0.0,
            0.04
          ],
          "radius": 0.205,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.17,
            0.0,
            0.025
          ],
          "radius": 0.216,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.43,
            0.0,
            0.03
          ],
          "radius": 0.206,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284b98": {
      "sourceAddress": "0x0c284b98",
      "sourceSha256": "3a23b585bb41c9a7b7a963cd0842781c9895cfe627bb481195c14b841b69377a",
      "records": [
        {
          "localPosition": [
            0.18,
            0.015,
            -0.075
          ],
          "radius": 0.2,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.18,
            0.015,
            0.075
          ],
          "radius": 0.2,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.15,
            0.01,
            -0.005
          ],
          "radius": 0.193,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.295,
            0.0,
            0.005
          ],
          "radius": 0.202,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            0.01,
            0.005
          ],
          "radius": 0.193,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.295,
            0.0,
            -0.005
          ],
          "radius": 0.202,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284bde": {
      "sourceAddress": "0x0c284bde",
      "sourceSha256": "21e5dc93a4ad2d2e98e14cde2fc73ed8ebe253983c659c20a5780be604bd241b",
      "records": [
        {
          "localPosition": [
            0.145,
            0.02,
            0.045
          ],
          "radius": 0.178,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.145,
            0.02,
            -0.045
          ],
          "radius": 0.178,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.075,
            0.01,
            -0.01
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.19,
            0.005,
            -0.02
          ],
          "radius": 0.166,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.36,
            -0.025,
            0.01
          ],
          "radius": 0.165,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            0.01,
            0.01
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.19,
            0.005,
            0.02
          ],
          "radius": 0.166,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.36,
            -0.025,
            -0.01
          ],
          "radius": 0.165,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284c38": {
      "sourceAddress": "0x0c284c38",
      "sourceSha256": "756fb9bace72ac7f87766b13683da6528c73f7777670614991ea1f319d03df9a",
      "records": [
        {
          "localPosition": [
            0.14,
            0.02,
            0.055
          ],
          "radius": 0.168,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.14,
            0.02,
            -0.055
          ],
          "radius": 0.168,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.075,
            0.01,
            0.01
          ],
          "radius": 0.159,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.225,
            0.005,
            -0.045
          ],
          "radius": 0.167,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.315,
            0.01,
            -0.01
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.075,
            0.01,
            -0.01
          ],
          "radius": 0.159,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.225,
            0.005,
            0.045
          ],
          "radius": 0.167,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.315,
            0.01,
            0.01
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284c92": {
      "sourceAddress": "0x0c284c92",
      "sourceSha256": "166feecc86bbf94dfcbce0a34baa63808d4dc21a1ad3260f1b9d33fa652e4508",
      "records": [
        {
          "localPosition": [
            0.135,
            -0.01,
            -0.035
          ],
          "radius": 0.146,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            -0.045,
            -0.02
          ],
          "radius": 0.155,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.065,
            -0.025
          ],
          "radius": 0.165,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.145,
            -0.035,
            -0.03
          ],
          "radius": 0.18,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.015
          ],
          "radius": 0.184,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.135,
            -0.01,
            0.035
          ],
          "radius": 0.146,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            -0.045,
            0.02
          ],
          "radius": 0.155,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.065,
            0.025
          ],
          "radius": 0.165,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.145,
            -0.035,
            0.03
          ],
          "radius": 0.18,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.015
          ],
          "radius": 0.184,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284d00": {
      "sourceAddress": "0x0c284d00",
      "sourceSha256": "ec96fbaeb04fbfee05f0102c5041666483efec45ba7eb0011261f2b0c3e3992c",
      "records": [
        {
          "localPosition": [
            0.185,
            0.05,
            0.05
          ],
          "radius": 0.232,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.185,
            0.05,
            -0.05
          ],
          "radius": 0.232,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.18,
            0.0,
            -0.02
          ],
          "radius": 0.247,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.32,
            0.015,
            0.025
          ],
          "radius": 0.234,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.234,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.18,
            0.0,
            0.02
          ],
          "radius": 0.247,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.32,
            0.015,
            -0.025
          ],
          "radius": 0.234,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            0.0,
            0.0
          ],
          "radius": 0.234,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284d5a": {
      "sourceAddress": "0x0c284d5a",
      "sourceSha256": "7b98ce8ec0fbf89d51a14dbffcf84ec6b14f6dde53fcd63c149b7ddcf230ffc1",
      "records": [
        {
          "localPosition": [
            -0.06,
            0.025,
            -0.02
          ],
          "radius": 0.164,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.045,
            0.005,
            -0.03
          ],
          "radius": 0.172,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.18,
            0.0,
            0.0
          ],
          "radius": 0.195,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.06,
            0.025,
            0.02
          ],
          "radius": 0.164,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.045,
            0.005,
            0.03
          ],
          "radius": 0.172,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.18,
            0.0,
            0.0
          ],
          "radius": 0.195,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284da0": {
      "sourceAddress": "0x0c284da0",
      "sourceSha256": "28b8d826bcfc95b9c24830ee0564364723acb30bdd1444cff7ba0c0b2c5a3208",
      "records": [
        {
          "localPosition": [
            0.06,
            -0.02,
            -0.04
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            0.0,
            -0.015
          ],
          "radius": 0.144,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.34,
            0.0,
            -0.02
          ],
          "radius": 0.155,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.11,
            -0.005,
            -0.02
          ],
          "radius": 0.155,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.24,
            -0.005,
            -0.02
          ],
          "radius": 0.163,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.335,
            0.0,
            -0.025
          ],
          "radius": 0.163,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.02,
            -0.085,
            -0.015
          ],
          "radius": 0.146,
          "controllerType": 34,
          "collisionMaskBit": 4096
        },
        {
          "localPosition": [
            0.06,
            -0.02,
            0.04
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            0.0,
            0.015
          ],
          "radius": 0.144,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.34,
            0.0,
            0.02
          ],
          "radius": 0.155,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.11,
            -0.005,
            0.02
          ],
          "radius": 0.155,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.24,
            -0.005,
            0.02
          ],
          "radius": 0.163,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.335,
            0.0,
            0.025
          ],
          "radius": 0.163,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            -0.015,
            -0.085,
            -0.015
          ],
          "radius": 0.146,
          "controllerType": 27,
          "collisionMaskBit": 32768
        }
      ]
    },
    "0x0c284e36": {
      "sourceAddress": "0x0c284e36",
      "sourceSha256": "b3342aac453b0e39a1da8a68a0f7e3690ebeee2361219318c085bbe4f42736eb",
      "records": [
        {
          "localPosition": [
            0.06,
            -0.02,
            -0.04
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            0.0,
            -0.015
          ],
          "radius": 0.144,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.34,
            0.0,
            -0.02
          ],
          "radius": 0.155,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.11,
            -0.005,
            -0.02
          ],
          "radius": 0.155,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.24,
            -0.005,
            -0.02
          ],
          "radius": 0.163,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.35,
            0.0,
            -0.01
          ],
          "radius": 0.168,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.01,
            -0.025,
            -0.015
          ],
          "radius": 0.153,
          "controllerType": 34,
          "collisionMaskBit": 4096
        },
        {
          "localPosition": [
            0.06,
            -0.02,
            0.04
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            0.0,
            0.015
          ],
          "radius": 0.144,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.34,
            0.0,
            0.02
          ],
          "radius": 0.155,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.11,
            -0.005,
            0.02
          ],
          "radius": 0.155,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.24,
            -0.005,
            0.02
          ],
          "radius": 0.163,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.35,
            0.0,
            0.01
          ],
          "radius": 0.168,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            -0.015,
            -0.085,
            -0.015
          ],
          "radius": 0.146,
          "controllerType": 27,
          "collisionMaskBit": 32768
        }
      ]
    },
    "0x0c284ecc": {
      "sourceAddress": "0x0c284ecc",
      "sourceSha256": "162668322b2000a32b915edb24a5aa9e2125f4322ea876d3ee5fc7bbcb53f6b6",
      "records": [
        {
          "localPosition": [
            0.23,
            0.02,
            0.06
          ],
          "radius": 0.245,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.215,
            0.02,
            -0.06
          ],
          "radius": 0.245,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.18,
            -0.005,
            -0.025
          ],
          "radius": 0.237,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.34,
            -0.02,
            -0.01
          ],
          "radius": 0.22,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.095,
            -0.035,
            -0.005
          ],
          "radius": 0.21,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.18,
            -0.005,
            0.025
          ],
          "radius": 0.237,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.34,
            -0.02,
            0.01
          ],
          "radius": 0.22,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.095,
            -0.035,
            0.005
          ],
          "radius": 0.21,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c284f26": {
      "sourceAddress": "0x0c284f26",
      "sourceSha256": "bd34c3c02441919d325941d3e48d0b87c23a3ede84363721ff15f97d15ca56ef",
      "records": [
        {
          "localPosition": [
            0.05,
            0.01,
            0.11
          ],
          "radius": 0.179,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.05,
            0.01,
            -0.11
          ],
          "radius": 0.179,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            -0.02,
            0.015,
            -0.005
          ],
          "radius": 0.205,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.135,
            -0.01,
            -0.015
          ],
          "radius": 0.224,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.32,
            -0.03,
            -0.01
          ],
          "radius": 0.189,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.02,
            0.015,
            0.005
          ],
          "radius": 0.205,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.135,
            -0.01,
            0.015
          ],
          "radius": 0.224,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.32,
            -0.03,
            0.01
          ],
          "radius": 0.189,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284f80": {
      "sourceAddress": "0x0c284f80",
      "sourceSha256": "beacec1142dd6e9508db233f30c769af5e723d4b42bc95193dfd87e82a13a391",
      "records": [
        {
          "localPosition": [
            0.155,
            0.02,
            0.075
          ],
          "radius": 0.161,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.02,
            -0.075
          ],
          "radius": 0.161,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.095,
            0.01,
            -0.01
          ],
          "radius": 0.168,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            0.02,
            0.0
          ],
          "radius": 0.176,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.095,
            0.01,
            0.01
          ],
          "radius": 0.168,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            0.02,
            0.0
          ],
          "radius": 0.176,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c284fc6": {
      "sourceAddress": "0x0c284fc6",
      "sourceSha256": "bc18406f27043de4faff1c9dfbe838efa5d7534584658549190c47e50aec9c67",
      "records": [
        {
          "localPosition": [
            0.155,
            0.005,
            0.065
          ],
          "radius": 0.223,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.155,
            0.005,
            -0.065
          ],
          "radius": 0.223,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.11,
            -0.005,
            -0.02
          ],
          "radius": 0.222,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            -0.02,
            0.015
          ],
          "radius": 0.219,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.11,
            -0.005,
            0.02
          ],
          "radius": 0.222,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            -0.02,
            -0.015
          ],
          "radius": 0.219,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c28500c": {
      "sourceAddress": "0x0c28500c",
      "sourceSha256": "5d3f4c897dae0832ccdcd50e1f24866d67dd1080beedc8ed7f386dad1fb02287",
      "records": [
        {
          "localPosition": [
            -0.01,
            0.0,
            -0.055
          ],
          "radius": 0.162,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.15,
            -0.015,
            -0.03
          ],
          "radius": 0.147,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.28,
            -0.02,
            -0.02
          ],
          "radius": 0.143,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.035,
            -0.01,
            -0.02
          ],
          "radius": 0.143,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.205,
            0.0,
            -0.025
          ],
          "radius": 0.138,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            -0.01,
            0.0,
            0.055
          ],
          "radius": 0.162,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.15,
            -0.015,
            0.03
          ],
          "radius": 0.147,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.28,
            -0.02,
            0.02
          ],
          "radius": 0.143,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.035,
            -0.01,
            0.02
          ],
          "radius": 0.143,
          "controllerType": 25,
          "collisionMaskBit": 16384
        },
        {
          "localPosition": [
            0.205,
            0.0,
            0.025
          ],
          "radius": 0.138,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c28507a": {
      "sourceAddress": "0x0c28507a",
      "sourceSha256": "6c84819a14c07f0cbd6d704edfd4952abfc57b73d28afb68265c86f0d8bef626",
      "records": [
        {
          "localPosition": [
            0.235,
            -0.035,
            0.035
          ],
          "radius": 0.231,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.235,
            -0.035,
            -0.035
          ],
          "radius": 0.231,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.175,
            -0.005,
            -0.01
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.345,
            -0.02,
            0.0
          ],
          "radius": 0.202,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.175,
            -0.005,
            0.01
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.345,
            -0.02,
            0.0
          ],
          "radius": 0.202,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2850c0": {
      "sourceAddress": "0x0c2850c0",
      "sourceSha256": "7aa8f2f7cbb2271f56901166fb34d0ee84f11f709e87520431d7a7ca903a7279",
      "records": [
        {
          "localPosition": [
            0.068,
            0.005,
            -0.025
          ],
          "radius": 0.169,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.18,
            -0.005,
            -0.015
          ],
          "radius": 0.168,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.015,
            -0.01,
            -0.01
          ],
          "radius": 0.146,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.068,
            0.005,
            0.025
          ],
          "radius": 0.169,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.18,
            -0.005,
            0.015
          ],
          "radius": 0.168,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            -0.015,
            -0.01,
            0.01
          ],
          "radius": 0.146,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c285106": {
      "sourceAddress": "0x0c285106",
      "sourceSha256": "95bcf295b7070330a11dfa5775bcacfb942cc44e03a3addee8f4d9ec06de097c",
      "records": [
        {
          "localPosition": [
            0.17,
            0.01,
            0.07
          ],
          "radius": 0.212,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.17,
            0.01,
            -0.07
          ],
          "radius": 0.212,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.105,
            0.01,
            -0.04
          ],
          "radius": 0.209,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.255,
            0.015,
            0.01
          ],
          "radius": 0.197,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.0,
            -0.055,
            -0.035
          ],
          "radius": 0.246,
          "controllerType": 32,
          "collisionMaskBit": 2048
        },
        {
          "localPosition": [
            0.105,
            0.01,
            0.04
          ],
          "radius": 0.209,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.255,
            0.015,
            -0.01
          ],
          "radius": 0.197,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.0,
            -0.055,
            0.035
          ],
          "radius": 0.246,
          "controllerType": 25,
          "collisionMaskBit": 16384
        }
      ]
    },
    "0x0c285160": {
      "sourceAddress": "0x0c285160",
      "sourceSha256": "525bddc2b4a352356c9805e957f6b60307b7cf1b2b2d74b109f35c68534659d5",
      "records": [
        {
          "localPosition": [
            -0.03,
            0.005,
            -0.03
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.1,
            0.01,
            -0.035
          ],
          "radius": 0.186,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.225,
            0.0,
            -0.035
          ],
          "radius": 0.197,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.3,
            0.0,
            -0.035
          ],
          "radius": 0.196,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            -0.03,
            0.005,
            0.03
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.1,
            0.01,
            0.035
          ],
          "radius": 0.186,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.225,
            0.0,
            0.035
          ],
          "radius": 0.197,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.3,
            0.0,
            0.035
          ],
          "radius": 0.196,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c2851ba": {
      "sourceAddress": "0x0c2851ba",
      "sourceSha256": "dea154c05c2b8953eedefb4e09a3641e35140e79c68ae368b111c634fa1679ef",
      "records": [
        {
          "localPosition": [
            0.06,
            -0.045,
            0.075
          ],
          "radius": 0.133,
          "controllerType": 2,
          "collisionMaskBit": 2
        },
        {
          "localPosition": [
            0.06,
            -0.045,
            -0.075
          ],
          "radius": 0.133,
          "controllerType": 2,
          "collisionMaskBit": 2
        },
        {
          "localPosition": [
            0.035,
            0.01,
            0.065
          ],
          "radius": 0.168,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.035,
            0.01,
            -0.065
          ],
          "radius": 0.168,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.025,
            0.005,
            -0.025
          ],
          "radius": 0.192,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.025,
            0.005,
            0.025
          ],
          "radius": 0.192,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    },
    "0x0c285200": {
      "sourceAddress": "0x0c285200",
      "sourceSha256": "b6546c172b7549980d9ade46ff7d56482466c90f8bc00121a24af62e963cdd15",
      "records": [
        {
          "localPosition": [
            0.125,
            0.0,
            0.055
          ],
          "radius": 0.158,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.125,
            0.0,
            -0.055
          ],
          "radius": 0.158,
          "controllerType": 20,
          "collisionMaskBit": 512
        },
        {
          "localPosition": [
            0.02,
            0.005,
            -0.04
          ],
          "radius": 0.179,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.195,
            -0.01,
            -0.03
          ],
          "radius": 0.182,
          "controllerType": 31,
          "collisionMaskBit": 1024
        },
        {
          "localPosition": [
            0.02,
            0.005,
            0.04
          ],
          "radius": 0.179,
          "controllerType": 24,
          "collisionMaskBit": 8192
        },
        {
          "localPosition": [
            0.195,
            -0.01,
            0.03
          ],
          "radius": 0.182,
          "controllerType": 24,
          "collisionMaskBit": 8192
        }
      ]
    }
  },
  "runtimeModeOverrideProfiles": {
    "1": "0x0c281b78",
    "2": "0x0c281c0e",
    "4": "0x0c281ca4",
    "6": "0x0c281d26",
    "7": "0x0c281dbc"
  },
  "solver": {
    "fixedFramesPerSecond": 30,
    "pinnedAnchorHighNibble": 16,
    "firstDynamicRow": 1,
    "force": {
      "magnitude": 0.05444444715976715,
      "literalAddresses": [
        "0x0c0af648",
        "0x0c0af7a4"
      ],
      "fixedDownwardLiteralAddress": "0x0c0af3ec",
      "fixedDownwardProfileByte0x0a": [
        4
      ],
      "fixedDownwardRuntimeModes": [
        1,
        2,
        5
      ],
      "fixedDownwardModelRules": [
        {
          "modelCode": "NAT",
          "exceptControlTypes": [
            -70
          ],
          "literalAddress": "0x0c0af3e8"
        }
      ],
      "primaryControllerPairByProfileByte0x0a": {
        "1": [
          34,
          27
        ],
        "2": [
          31,
          24
        ],
        "3": [
          32,
          25
        ]
      },
      "fixedDownwardConstruction": {
        "controllerPair": [
          0,
          0
        ],
        "midpointYOffset": -2.0
      },
      "fixedDownwardControllerYOffsetLiteralAddress": "0x0c0af640",
      "secondaryControllerPairByProfileByte0x0b": {
        "1": [
          34,
          27
        ],
        "2": [
          31,
          24
        ],
        "3": [
          32,
          25
        ]
      },
      "controlTypeControllerPairs": {
        "-78": [
          27,
          0
        ],
        "-77": [
          34,
          0
        ],
        "-76": [
          12,
          10
        ],
        "-75": [
          18,
          16
        ]
      }
    },
    "openPanelControlTypes": [
      -71,
      -72,
      -73,
      -74
    ],
    "closedRingControlTypes": [
      -70,
      -75,
      -76,
      -77,
      -78
    ],
    "closedRingAuthoredSpacingScale": 0.3,
    "closedRingAuthoredSpacingScaleLiteralAddress": "0x0c0af8d0",
    "closedRingMeasuredMaximumBodyRadiusScale": 2.0,
    "closedRingMeasuredMaximumBodyRadiusScaleLiteralAddress": "0x0c0afe68",
    "teleportDistance": 1.8,
    "teleportDistanceLiteralAddress": "0x0c0af8c8",
    "groundClearance": 0.02,
    "groundClearanceLiteralAddress": "0x0c0b04c4",
    "runtimeMode4AdvectionField": {
      "sourceAddress": "0x0c281e2c",
      "rows": 8,
      "columns": 20,
      "coefficients": [
        [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0
        ],
        [
          0.29999998211860657,
          0.3999999761581421,
          0.3999999761581421,
          0.29999998211860657,
          0.29999998211860657,
          0.09999999403953552,
          0.29999998211860657,
          0.29999998211860657,
          0.3999999761581421,
          0.3999999761581421,
          0.3999999761581421,
          0.29999998211860657,
          0.19999998807907104,
          0.09999999403953552,
          0.09999999403953552,
          0.0,
          0.0,
          0.09999999403953552,
          0.09999999403953552,
          0.19999998807907104
        ],
        [
          0.29999998211860657,
          0.5,
          0.5,
          0.3999999761581421,
          0.29999998211860657,
          0.19999998807907104,
          0.29999998211860657,
          0.29999998211860657,
          0.5,
          0.5,
          0.5,
          0.29999998211860657,
          0.19999998807907104,
          0.19999998807907104,
          0.09999999403953552,
          0.0,
          0.0,
          0.09999999403953552,
          0.19999998807907104,
          0.19999998807907104
        ],
        [
          0.3999999761581421,
          0.5999999642372131,
          0.5999999642372131,
          0.3999999761581421,
          0.3999999761581421,
          0.29999998211860657,
          0.3999999761581421,
          0.3999999761581421,
          0.5999999642372131,
          0.5999999642372131,
          0.5999999642372131,
          0.3999999761581421,
          0.29999998211860657,
          0.19999998807907104,
          0.09999999403953552,
          0.0,
          0.0,
          0.09999999403953552,
          0.19999998807907104,
          0.29999998211860657
        ],
        [
          0.5,
          0.699999988079071,
          0.699999988079071,
          0.5,
          0.5999999642372131,
          0.5999999642372131,
          0.5999999642372131,
          0.5999999642372131,
          0.699999988079071,
          0.699999988079071,
          0.699999988079071,
          0.5,
          0.3999999761581421,
          0.29999998211860657,
          0.19999998807907104,
          0.0,
          0.0,
          0.19999998807907104,
          0.29999998211860657,
          0.3999999761581421
        ],
        [
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.8999999761581421,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.699999988079071,
          0.5999999642372131,
          0.5,
          0.0,
          0.0,
          0.5,
          0.5999999642372131,
          0.699999988079071
        ],
        [
          0.7999999523162842,
          0.8999999761581421,
          0.8999999761581421,
          0.7999999523162842,
          0.8999999761581421,
          1.0,
          0.8999999761581421,
          0.7999999523162842,
          0.8999999761581421,
          0.8999999761581421,
          0.8999999761581421,
          0.7999999523162842,
          0.7999999523162842,
          0.7999999523162842,
          0.5999999642372131,
          0.09999999403953552,
          0.09999999403953552,
          0.5999999642372131,
          0.7999999523162842,
          0.7999999523162842
        ],
        [
          1.0,
          1.0,
          1.0,
          1.0,
          1.0,
          1.1999999284744263,
          1.0,
          1.0,
          1.0,
          1.0,
          1.0,
          1.0,
          0.8999999761581421,
          0.8999999761581421,
          0.7999999523162842,
          0.19999998807907104,
          0.19999998807907104,
          0.7999999523162842,
          0.8999999761581421,
          0.8999999761581421
        ]
      ]
    },
    "positionUpdateFunction": "0x0c0af35e",
    "surfaceAuxiliaryUpdateFunction": "0x0c0b0512",
    "velocityDampingByProfileByte0x0d": {
      "default": [
        0.5,
        0.5,
        0.5
      ],
      "1": [
        0.8,
        0.65,
        0.8
      ],
      "2": [
        0.2,
        0.1,
        0.2
      ],
      "3": [
        1.0,
        1.0,
        1.0
      ]
    }
  }
});

export const NATIVE_CLOTH_CHARACTER_PROFILES = DATA.characterProfiles;
export const NATIVE_CLOTH_FALLBACK_PROFILE = DATA.fallbackProfile;
export const NATIVE_CLOTH_BODY_COLLISION_PROFILES = DATA.bodyCollisionProfiles;
export const NATIVE_CLOTH_RUNTIME_MODE_OVERRIDE_PROFILES = (
  DATA.runtimeModeOverrideProfiles
);
export const NATIVE_CLOTH_SOLVER_PROFILE = DATA.solver;
